import React, { useState, useEffect, useRef } from "react";
import { useModals } from "@mantine/modals";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useNavigation, useParams } from "react-router-dom";
import { NumberInput, Radio, Select, Stepper, List, Text, Button } from "@mantine/core";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import { Modal } from "@mantine/core";
import { ReactComponent as Logo } from "../../assets/logo.svg";
import { ReactComponent as Back } from "../../assets/modalBackIcon.svg";
import { ReactComponent as Close } from "../../assets/modalCloseIcon.svg";
import { ReactComponent as CheckIcon } from "../../assets/Check.svg";
import { ReactComponent as SelectIcon } from "../../assets/fi-rr-angle-small-down.svg";
import { ReactComponent as UploadIcon } from "../../assets/humbleicons_upload.svg";
import { ReactComponent as CircleTickIcon } from "../../assets/circle_tick.svg";


import "../home/components/checkEligibility/modal/eligibilityModal.css";
import CustomButton from "../../components/CustomButton";
import TravelerInformation from "../home/components/checkFileaClaim/modal/steppers/TravelerInformation";
import SaveOrContinueAsGuest from "../home/components/checkFileaClaim/modal/steppers/SaveOrContinueAsGuest";
import ClaimDetails from "../home/components/checkFileaClaim/modal/steppers/ClaimDetails";
import OriginallyBookedFlights from "../home/components/checkFileaClaim/modal/steppers/OriginallyBookedFlights";
import ActualFlightTaken from "../home/components/checkFileaClaim/modal/steppers/ActualFlightTaken";
import UploadRequiredDocument from "../home/components/checkFileaClaim/modal/steppers/UploadRequiredDocument";
import Attorneynotes from "../home/components/checkFileaClaim/modal/steppers/Attorneynotes";
import ConfirmationStatus from "../home/components/checkFileaClaim/modal/steppers/ConfirmationStatus";
import { useForm, Controller, set } from "react-hook-form";
import { CountryDropdown } from "react-country-region-selector";
import axios from "axios";
import moment from "moment";
import base_url from "../../api/bootapi";
import Swal from "sweetalert2";
import AsyncSelect from "react-select/async";
import AgreementModal from "./AgreementModal";
import DocuSignModal from "./DocuSignModal";
import PowerModal from "./PowerModal";
import PowerOfAttorney from "./PowerOfAttorney";
import { RemoveCircleOutline } from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import SuccessPopUp from "../../components/SuccessPopUp";
import attachmenturl from "../../api/attachmenturl";
import SurewanttoExit from "../../components/SurewanttoExit";
import { current } from "@reduxjs/toolkit";
import RegisterComponent from "../../components/authComponent/RegisterComponent";
import LoginComponent from "../../components/authComponent/LoginComponent";
import { IconPlaneArrival, IconPlaneDeparture } from "@tabler/icons-react";

const FileaClaim = ({ open, close }) => {
  const modals = useModals();

  const [lostAmount,setLostAmount] =useState(null)
  const handleClose = () => {
    modals.openConfirmModal({
      title: "Confirm Close",
      children: "Are you sure you want to exit?",
      labels: { confirm: "Yes", cancel: "No" },
      onConfirm: () => {
        // Clear all localStorage keys used by child components
        localStorage.removeItem("travelerInformationData");
        localStorage.removeItem("claimType");
        localStorage.removeItem("OriginallyBookedFlightsData");
        localStorage.removeItem("actualFlightDetailsData");

        // Navigate to the start page
        navigate("/start-your-claim");
      },
    });
  };
  const [additionalClaimData, setAdditionalClaimData] = useState([
    {
      claim_type: "",
      claim_explanation: "",
      amount: "",
      other_claim_doc: null,
      currency_type: "usd",
      other_claim_doc_name: null,
    },
  ]);

  // //console.log("Addtional CLaim Data ============> ", additionalClaimData);
  const [additionalClaimValidation, setAdditionalClaimValidation] = useState([
    {
      claim_type: false,
      amount: false,
      claim_explanation: false,
      other_claim_doc: false,
    },
  ]);

  const [subclaimRemoveIds, setSubclaimRemoveIds] = useState([]);
  const [flightRemoveIds, setFlightRemoveIds] = useState([]);
  const [actualRemoveIds, setActualRemoveIds] = useState([]);
  const [otherclaimRemoveIds, setOtherclaimRemoveIds] = useState([]);

  const [familyMembers, setFamilyMembers] = useState([]);
  const { user } = useSelector((state) => state.user);
  const [isFlightProvided, setIsFlightProvided] = useState(null);
  const powerData = useSelector((state) => state.claimForm);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    control,
    watch,
  } = useForm();

  useEffect(() => {
    register("date_of_birth", { required: "Date of Birth is required" });
  }, [register]);

  const navigate = useNavigate();
  const powerRef = useRef(null);

  const [backdropopen, setbackdropopen] = useState(false);
  const [country1, setcountry] = useState("United States");
  const [countryValid, setCountryValid] = useState(false);
  const dispatch = useDispatch();

  const [defaultOptions, setDefaultOptions] = useState([]);
  const [defaultAirlineOptions, setDefaultAirlineOptions] = useState([]);

  const [selectedOriginOption, setSelectedOriginOption] = useState(null);
  const [selectedDestOption, setSelectedDestOption] = useState(null);
  const [selectedAirlineOption, setSelectedAirlineOption] = useState(null);
  const [selectedHomeOption, setSelectedHomeOption] = useState(null);
  const [signUrl, setSignUrl] = useState(null);

  const [selectedHour, setSelectedHour] = useState("");
  const [selectedMinute, setSelectedMinute] = useState("");
  const [hourStatus, setHourStatus] = useState(false);
  const [minStatus, setMinStatus] = useState(false);

  const [optionsList, setOptionsList] = useState([]);
  const [isOpenList, setIsOpenList] = useState(false);
  const [isAddressDropdownOpen, setIsAddressDropdownOpen] = useState(false);
  const [selectedAdditionalFiles, setSelectedAdditionalFiles] = useState(null);
  const [selectedLuggageFiles, setSelectedLuggageFiles] = useState(null);
  const [selectPassportFile, setSelectPassportFile] = useState(null);
  const [selectBoardingFile, setSelectBoardingFile] = useState(null);
  const [selectedPassportSubClaim, setSelectedPassportSubClaim] = useState([]);
  const [isTermsChecked, setIsTermsChecked] = useState(false);
  const [isAgreementChecked, setIsAgreementChecked] = useState(false);
  const [isPowerOfAttorneyChecked, setIsPowerOfAttorneyChecked] =
    useState(false);
  const [pdfBlob, setPdfBlob] = useState(null);
  const [signatureCaptured, setSignatureCaptured] = useState(false);
  const [isTermsLinkClicked, setIsTermsLinkClicked] = useState(false);
  const [isAgreementLinkClicked, setIsAgreementLinkClicked] = useState(false);
  const [isPowerLinkClicked, setIsPowerLinkClicked] = useState(false);
  const [envolpeId, setEnvelopeId] = useState();
  const [isFetching, setIsFetching] = useState(false);
  const [isDocuSignModalOpen, setIsDocusignModalOpen] = useState(false);
  const [documentFetched, setDocumentFetched] = useState(false);
  const [intervalId, setIntervalId] = useState(null);
  const [isDocumentFetching, setIsDocumentFetching] = useState(false);
  const [triggerIndex, setTriggerIndex] = useState(null);
  const [dataToStore, setDataToStore] = useState(null);
  const [triggerFrom, setTriggerFrom] = useState("original");
  const [email, setEmail] = useState(null);

  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [imageModalTitle, setImageModalTitle] = useState("");
  const [imageModalFileUrl, setImageModalFileUrl] = useState("");

  const formatDOB = (dateOfBirth) => {
    // const parts = dateOfBirth?.split?.("-");

    // if (parts?.length !== 3) {
    //   const today = new Date();
    //   const yyyy = today.getFullYear();
    //   const mm = String(today.getMonth() + 1).padStart(2, "0");
    //   const dd = String(today.getDate()).padStart(2, "0");
    //   return `${yyyy}-${mm}-${dd}`;
    // }

    // const [month, day, year] = parts;
    // return year?.length === 4
    //   ? `${year}-${month}-${day}`
    //   : `${day}-${month}-${year}`;

    return moment(dateOfBirth, "MM-DD-YYYY").format("YYYY-MM-DD");
  };

  const clearLocalStorage = () => {
    const keysToRemove = [
      "travelerInformationData",
      "claimType",
      "OriginallyBookedFlightsData",
      "actualFlightDetailsData",
      "completedStep",
    ];

    keysToRemove.forEach((key) => localStorage.removeItem(key));
  };

  const openImageViewModal = (title, fileUrl) => {
    setImageModalTitle(title);
    setImageModalFileUrl(fileUrl);
    setImageModalOpen(true);
  };

  const isImageFile = (url) => {
    // Example function to check if the URL ends with a common image file extension
    return /\.(jpeg|jpg|png|gif)$/i.test(url);
  };

  const handleViewFile = (elem) => {
    if (!elem) {
      return;
    }
    ////console.log("Element", attachmenturl + elem);
    const fileUrl = attachmenturl + elem;
    if (!isImageFile(fileUrl)) {
      window.open(fileUrl, "_blank"); // Open the URL in a new tab
    } else {
      openImageViewModal("View File", fileUrl); // Open the file in the modal
    }
  };

  const handleTermsChange = (event) => {
    if (isTermsLinkClicked) {
      setIsTermsChecked(event.target.checked);
    } else {
      event.preventDefault();
      Swal.fire({
        title: "Please read the Terms and Conditions",
        text: "You must click on the Terms and Conditions link and read them before checking the checkbox.",
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
  };
  function calculateDelay(actualArrivalTime, originalArrivalTime) {
    const duration = moment.duration(
      moment(actualArrivalTime).diff(moment(originalArrivalTime))
    );

    const isNegative = duration.asMilliseconds() < 0;
    const totalMinutes = Math.abs(duration.asMinutes());
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    const formatted = `${isNegative ? "-" : ""}${hours
      .toString()
      .padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;

    return formatted;
  }

  const [flightDetails, setFlightDetails] = useState([
    {
      airline: "",
      flight_number: "",
      airport_of_origin: "",
      airport_of_destination: "",
      date_of_travel: "",
      original_departure_time: "",
      original_arrival_time: "",
      original_departure_date: "",
      original_arrival_date: "",
      hub_code: "",
      iata_code:"",
flight_class:"Economy",
      // New fields for the enhanced form logic
      ticket_ref_no: "",
      disruption: "", // delayed, cancelled, missed
      delay_duration: "", // Less than 3 hours, 3–4 hours, 4+ hours
      flight_cancel: "", // Before arriving at the airport, At the airport
      missed_connection: "", // Flight delay, Airline error, Personal reasons
      // claim_details: "", // Any additional information provided by the user
delay_duration_minutes:"",
      additional_details: "",
      search_by:"airline_name",
      delayed: false,
      cancelled: false,
      missed: false,
      cancellation_info_before: false,
      cancellation_info_at_airport: false,
      missed_due_to_error: false,
      missed_due_to_personal: false,
    },
  ]);

  const [actualFlightDetails, setActualFlightDetails] = useState([
    {
      actual_airline: "",
      actual_flight_number: "",
      actual_airport_of_origin: "",
      actual_airport_of_destination: "",
      actual_date_of_travel: "",
      actual_departure_time: "",
      actual_arrival_time: "",
      actual_departure_date: "",
      actual_arrival_date: "",
      search_by:"airline_name",
actual_flight_class:"Economy",
      // claim_details: "", // Any additional information provided by the user
      actual_hub_code: "",
      ticket_ref_no: "",
      provided_by_airline: false,
      self_booked: false,
      same_as_original: false,
    },
  ]);

  const [delay, setDelay] = useState("00:00");

  const tabs = [
    {
      id: "flight delay / flight cancellation",
      label: "Flight Delay / Flight Cancellation",
    },
    { id: "general claims", label: "General Claims" },
  ];

  const [activeTab, setActiveTab] = useState(
    localStorage.getItem("activeClaimTab") ||
      "flight delay / flight cancellation"
  );

  const handleTabClick = (tabId) => {
    //console.log("Clicked");
    setbackdropopen(true);
    localStorage.setItem("activeClaimTab", tabId);
    setActiveTab(tabId);
    setTimeout(() => {
      setbackdropopen((prev) => !prev);
      window.location.reload();
    }, 200);
  };

  const handleBack = () => {
    
                     if (getformData?.claimDetails?.type_of_claim === "cancelled" && active === 5) {
                       setActive((current) => current - 2);
                     }else if (getformData?.claimDetails?.type_of_claim === "lost/damaged" && active === 4) {
                       setActive((current) => current - 2);
                    }
                    
                     else if (active > 1) {
                       setActive((current) => current - 1);
                      
                    }
                  
  }

  const [flightOptions, setFlightOptions] = useState({});
  const flightClassOptions = [
    { value: "First", label: "First" },
    { value: "Business", label: "Business" },
    { value: "Premium", label: "Premium" },
    { value: "Economy", label: "Economy" },
  ];




  useEffect(() => {
    const onBack = () => {
      if (isDocuSignModalOpen) {
        setIsDocusignModalOpen(false); // Close modal
      }
    };

    window.addEventListener("popstate", onBack);
    return () => window.removeEventListener("popstate", onBack);
  }, [isDocuSignModalOpen]);







  const getDelayDuration = (scheduled, actual) => {
    if (
      scheduled &&
      scheduled !== null &&
      scheduled !== undefined &&
      scheduled !== "" &&
      scheduled !== "+00:00" && scheduled !== "" &&
      actual &&
      actual !== null &&
      actual !== undefined &&
      actual !== "" &&
      actual !== "+00:00" &&
      actual !== ""
    ) {
      try {
       
        
        
        
         const ms = moment.utc(actual.slice(0,16)).diff(moment.utc(scheduled.slice(0,16)));
  const mins = Math.floor(moment.duration(ms).asMinutes());
  return   mins ;
        
      } catch (error) {
        console.error("Error calculating delay duration:", error);
        return 0;
      }
    }
    return 0;
  };

  // requires moment.js




  useEffect(() => {
    //console.log("trigggerindex", triggerIndex);

    if (triggerIndex !== null) {
      const flight =
        triggerFrom === "actual"
          ? actualFlightDetails[triggerIndex]
          : flightDetails[triggerIndex];

      const isValidDate = (str) => {
        return moment(str, "MM-DD-YYYY", true).isValid();
      };
      if (
        flight?.date_of_travel &&
        isValidDate(flight.date_of_travel) &&
        flight?.hub_code &&
        flight?.flight_number &&
        triggerFrom === "original"
      ) {
        //console.log("170");
        fetchFlightOptions(triggerIndex);
      } else if (
        flight?.actual_date_of_travel &&
        isValidDate(flight?.actual_date_of_travel) &&
        flight?.actual_hub_code &&
        flight?.actual_flight_number &&
        triggerFrom === "actual"
      ) {
        fetchFlightOptions(triggerIndex);
      }
    }
  }, [triggerIndex, flightDetails, actualFlightDetails]);


const OlddateFormat = (dateString, timeZone) => {
  if (!dateString) return "";

  try {
    const tz = timeZone || "UTC"; // fallback to UTC
    const dateObj = new Date(dateString);
    if (isNaN(dateObj)) return "";

    // Format date as MM-DD-YYYY
    const month = new Intl.DateTimeFormat("en-US", { month: "2-digit", timeZone: tz }).format(dateObj);
    const day = new Intl.DateTimeFormat("en-US", { day: "2-digit", timeZone: tz }).format(dateObj);
    const year = new Intl.DateTimeFormat("en-US", { year: "numeric", timeZone: tz }).format(dateObj);

    const date = `${month}-${day}-${year}`;

    // Format time in 12-hour with AM/PM
    const time = new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: tz,
    }).format(dateObj);

    return { date, time };
  } catch (err) {
    console.error("Invalid date or timezone", err);
    return { date: "", time: "" };
  }
};

  
  const dateFormat = (dateString) => {
  if (!dateString) return "";

  try {
   
        const dateStr = dateString.slice(0, 16);

    const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;
    
    if (!regex.test(dateStr)) return "";

    const date = moment(dateStr).format("MM-DD-YYYY");
    const time = moment(dateStr).format("HH:mm");

    console.log(date,time)


    return { date, time };
  } catch (err) {
    console.error("Invalid date or timezone", err);
    return { date: "", time: "" };
  }
};



  // Before Flight Stats fetch option
  
  // const fetchFlightOptions = async (index) => {
  //   const flight =
  //     triggerFrom === "actual"
  //       ? actualFlightDetails[index]
  //       : flightDetails[index];

  //   if (triggerFrom === "original") {
  //     if (
  //       !flight?.date_of_travel ||
  //       !flight?.hub_code ||
  //       !flight?.flight_number
  //     ) {
  //       Swal.fire({
  //         icon: "warning",
  //         title: "Missing Information",
  //         text: "Please fill in the original date of travel, airline, and flight number before proceeding!",
  //       });
  //       return;
  //     }
  //   } else if (triggerFrom === "actual") {
  //     // //console.log(
  //     //   "200",
  //     //   flight.actual_date_of_travel,
  //     //   flight.actual_hub_code,
  //     //   flight.actual_airline
  //     // );
  //     if (
  //       !flight?.actual_date_of_travel ||
  //       !flight?.actual_hub_code ||
  //       !flight?.actual_flight_number
  //     ) {
  //       Swal.fire({
  //         icon: "warning",
  //         title: "Missing Information",
  //         text: "Please fill in the actual date of travel, airline, and flight number before proceeding!",
  //       });
  //       return;
  //     }
  //   }

  //   // setbackdropopen(true);
  //   try {
  //     const response = await axios.post(
  //       `${base_url.api1}/tourapp/flightaware_details`,
  //       {
  //         airline_code:
  //           triggerFrom === "original"
  //             ? flight.hub_code
  //             : flight.actual_hub_code,
  //         flight_number:
  //           triggerFrom === "original"
  //             ? flight.flight_number
  //             : flight.actual_flight_number,
  //         flight_date:
  //           triggerFrom === "original"
  //             ? formatDOB(flight.date_of_travel)
  //             : formatDOB(flight.actual_date_of_travel),
  //       }
  //     );
  //     //console.log("triggerFrom 204", triggerFrom);

  //     const flightOptionsData = response.data.Flight.map((flightData) => {
  //       const departureScheduled = flightData.departure.scheduled;
  //       const departureActual = flightData.departure.actual;
  //       const departureActualRunway = flightData.departure.actual_runway;
  //       const arrivalScheduled = flightData.arrival.scheduled;
  //       const arrivalActual = flightData.arrival.actual;

  //       const arrivalActualRunway = flightData.arrival.actual_runway;

  //       const departureEstimated = flightData.departure.estimated;
  //       const arrivalEstimated = flightData.arrival.estimated;
  //       const departureEstimatedRunway = flightData.departure.estimated_runway;
  //       const arrivalEstimatedRunway = flightData.arrival.estimated_runway;

  //       const delayDuration = getDelayDuration(arrivalScheduled, arrivalActual || arrivalActualRunway || arrivalEstimated || arrivalEstimatedRunway);
  //      console.log(delayDuration,departureActual,departureScheduled);
  //       return {
  //         value: `${flightData.departure.iata}-${flightData.arrival.iata}`,
  //         departure: {
  //           airport: flightData.departure.airport,
  //           iata: flightData.departure.iata,
  //           departureScheduled,
  //           timeZone:flightData.departure.timezone,
  //           departureActual :departureActual || departureActualRunway || departureEstimated || departureEstimatedRunway || departureScheduled,
  //         },
  //         arrival: {
  //           airport: flightData.arrival.airport,
  //           iata: flightData.arrival.iata,
  //           arrivalScheduled,
  //                       timeZone:flightData.arrival.timezone,

  //           arrivalActual :arrivalActual || arrivalActualRunway || arrivalEstimated || arrivalEstimatedRunway || arrivalScheduled,
  //         },
  //         delay_duration_minutes: delayDuration,
  //         label: `${flightData.arrival.airport} - ${flightData.departure.airport}`,
  //       };
  //     });

  //     const flightList = flightOptionsData[0]; // Get flight based on triggerIndex
     
  //     if (flightList) {
  //       const updatedFlightDetails =
  //         triggerFrom === "actual"
  //           ? [...actualFlightDetails]
  //           : [...flightDetails]; // Assuming flightDetails is a state variable.

  //       if (triggerFrom === "actual") {
  //         // const actualArrivalTime = flightList.arrival.arrivalActual || "";
  //         // const originalArrivalTime =
  //         //   updatedFlightDetails[triggerIndex].original_arrival_time || "";

  //         // let delay = "";
  //         // if (actualArrivalTime && originalArrivalTime) {
  //         //   delay = calculateDelay(actualArrivalTime, originalArrivalTime);
  //         //   setDelay(delay);
  //         // }

  //         updatedFlightDetails[triggerIndex] = {
  //           ...updatedFlightDetails[triggerIndex],
  //           actual_departure_time:
  //             flightList.departure.departureActual &&
  //             flightList.departure.departureActual !== null &&
  //             flightList.departure.departureActual !== undefined &&
  //             flightList.departure.departureActual !== "" &&
  //             flightList.departure.departureActual !== "+00:00"
  //               ? dateFormat(flightList.departure.departureActual,flightList.departure.timeZone)
                   
  //                   .time
  //               : "",
  //           actual_departure_date:
  //             flightList.departure.departureActual &&
  //             flightList.departure.departureActual !== null &&
  //             flightList.departure.departureActual !== undefined &&
  //             flightList.departure.departureActual !== "" &&
  //             flightList.departure.departureActual !== "+00:00"
  //               ?dateFormat(flightList.departure.departureActual,flightList.departure.timeZone)
                   
  //                   .date
  //               : "",
  //           actual_arrival_time:
  //             flightList.arrival.arrivalActual &&
  //             flightList.arrival.arrivalActual !== null &&
  //             flightList.arrival.arrivalActual !== undefined &&
  //             flightList.arrival.arrivalActual !== "" &&
  //             flightList.arrival.arrivalActual !== "+00:00"
  //               ? dateFormat( flightList.arrival.arrivalActual,flightList.arrival.timeZone)
                   
  //                   .time
  //               : "",
  //           actual_arrival_date:
  //             flightList.arrival.arrivalActual &&
  //             flightList.arrival.arrivalActual !== null &&
  //             flightList.arrival.arrivalActual !== undefined &&
  //             flightList.arrival.arrivalActual !== "" &&
  //             flightList.arrival.arrivalActual !== "+00:00"
  //               ?dateFormat( flightList.arrival.arrivalActual,flightList.arrival.timeZone)
                   
  //                   .date
  //               : "",

  //           actual_airport_of_origin: flightList.departure.airport || "",
  //           actual_airport_of_destination: flightList.arrival.airport || "",
  //           departure_iata_code: flightList.departure.iata || "",
  //           arrival_iata_code: flightList.arrival.iata || "",
  //           delay_duration_minutes: flightList.delay_duration_minutes || 0,
  //         };
  //       } else if (triggerFrom === "original") {
  //         // const originalArrivalTime = flightList.arrival.arrivalScheduled || "";
  //         // const actualArrivalTime =
  //         //   updatedFlightDetails[triggerIndex].actual_arrival_time || "";

  //         // let delay = "";
  //         // if (originalArrivalTime && actualArrivalTime) {
  //         //   delay = calculateDelay(actualArrivalTime, originalArrivalTime);
  //         //   setDelay(delay);
  //         // }

  //         updatedFlightDetails[triggerIndex] = {
  //           ...updatedFlightDetails[triggerIndex],
  //           airport_of_origin: flightList.departure.airport || "",
  //           airport_of_destination: flightList.arrival.airport || "",
  //           original_departure_time:
  //             flightList.departure.departureScheduled &&
  //             flightList.departure.departureScheduled !== null &&
  //             flightList.departure.departureScheduled !== undefined &&
  //             flightList.departure.departureScheduled !== "" &&
  //             flightList.departure.departureScheduled !== "+00:00"
  //               ? dateFormat( flightList.departure.departureScheduled,flightList.departure.timeZone)
                   
  //                   .time
  //               : "",
  //           original_departure_date:
  //             flightList.departure.departureScheduled &&
  //             flightList.departure.departureScheduled !== null &&
  //             flightList.departure.departureScheduled !== undefined &&
  //             flightList.departure.departureScheduled !== "" &&
  //             flightList.departure.departureScheduled !== "+00:00"
  //               ? dateFormat( flightList.departure.departureScheduled,flightList.departure.timeZone)
                   
  //                   .date
  //               : "",
  //           original_arrival_time:
  //             flightList.arrival.arrivalScheduled &&
  //             flightList.arrival.arrivalScheduled !== null &&
  //             flightList.arrival.arrivalScheduled !== undefined &&
  //             flightList.arrival.arrivalScheduled !== "" &&
  //             flightList.arrival.arrivalScheduled !== "+00:00"
  //               ? dateFormat( flightList.arrival.arrivalScheduled,flightList.arrival.timeZone)
                   
  //                   .time
  //               : "",
  //           original_arrival_date:
  //             flightList.arrival.arrivalScheduled &&
  //             flightList.arrival.arrivalScheduled !== null &&
  //             flightList.arrival.arrivalScheduled !== undefined &&
  //             flightList.arrival.arrivalScheduled !== "" &&
  //             flightList.arrival.arrivalScheduled !== "+00:00"
  //               ? dateFormat( flightList.arrival.arrivalScheduled,flightList.arrival.timeZone)
                   
  //                 .date
                
  //               : "",
  //           departure_iata_code: flightList.departure.iata || "",
  //           arrival_iata_code: flightList.arrival.iata || "",
  //           actual_departure_time:
  //             flightList.departure.departureActual &&
  //             flightList.departure.departureActual !== null &&
  //             flightList.departure.departureActual !== undefined &&
  //             flightList.departure.departureActual !== "" &&
  //             flightList.departure.departureActual !== "+00:00"
  //               ? dateFormat( flightList.departure.departureActual,flightList.departure.timeZone)
                   
  //                 .time
  //               : "",
  //           actual_departure_date:
  //             flightList.departure.departureActual &&
  //             flightList.departure.departureActual !== null &&
  //             flightList.departure.departureActual !== undefined &&
  //             flightList.departure.departureActual !== "" &&
  //             flightList.departure.departureActual !== "+00:00"
  //               ? dateFormat( flightList.departure.departureActual,flightList.departure.timeZone)
                   
  //                 .date
  //               : "",
  //           actual_arrival_time:
  //             flightList.arrival.arrivalActual &&
  //             flightList.arrival.arrivalActual !== null &&
  //             flightList.arrival.arrivalActual !== undefined &&
  //             flightList.arrival.arrivalActual !== "" &&
  //             flightList.arrival.arrivalActual !== "+00:00"
  //               ?dateFormat( flightList.arrival.arrivalActual,flightList.arrival.timeZone)
                   
  //                 .time
  //               : "",
  //           actual_arrival_date:
  //             flightList.arrival.arrivalActual &&
  //             flightList.arrival.arrivalActual !== null &&
  //             flightList.arrival.arrivalActual !== undefined &&
  //             flightList.arrival.arrivalActual !== "" &&
  //             flightList.arrival.arrivalActual !== "+00:00"
  //               ? dateFormat( flightList.arrival.arrivalActual,flightList.arrival.timeZone)
                   
  //                 .date
  //               : "",
            
  //           delay_duration_minutes: flightList.delay_duration_minutes || 0,
  //         };
  //       }

       
  //       if (triggerFrom === "actual") {
  //         setActualFlightDetails(updatedFlightDetails);
  //       } else {
  //         setFlightDetails(updatedFlightDetails);
  //       }
  //     }

  //     setTriggerIndex(null);

  //     const updatedFlightOptions = { ...flightOptions };
  //     updatedFlightOptions[index] = flightOptionsData;
  //     setFlightOptions(updatedFlightOptions);

  //     setbackdropopen(false);
  //   } catch (error) {
  //     console.error("Error fetching flight options:", error);
  //     setFlightOptions((prevState) => {
  //       const updatedFlightOptions = { ...prevState };
  //       updatedFlightOptions[index] = [];
  //       return updatedFlightOptions;
  //     });
  //     const updatedFlightDetails =
  //       triggerFrom === "actual"
  //         ? [...actualFlightDetails]
  //         : [...flightDetails];

  //     if (triggerFrom === "actual") {
  //       updatedFlightDetails[triggerIndex] = {
  //         ...updatedFlightDetails[triggerIndex],
  //         actual_departure_time: "",
  //         actual_arrival_time: "",
  //         actual_airport_of_origin: "",
  //         actual_airport_of_destination: "",
  //         delay: "",
  //         departure_iata_code: "",
  //         arrival_iata_code: "",
  //           delay_duration_minutes:  0,

  //       };
  //     } else if (triggerFrom === "original") {
  //       updatedFlightDetails[triggerIndex] = {
  //         ...updatedFlightDetails[triggerIndex],
  //         airport_of_origin: "",
  //         airport_of_destination: "",
  //         original_departure_time: "",
  //         original_arrival_time: "",
  //         departure_iata_code: "",
  //         arrival_iata_code: "",
  //           delay_duration_minutes:  0,

  //       };
  //     }

  //     if (triggerFrom === "actual") {
  //       setActualFlightDetails(updatedFlightDetails);
  //     } else {
  //       setFlightDetails(updatedFlightDetails);
  //     }

  //     setTriggerIndex(null);

  //     setbackdropopen(false);
  //   }

  //   console.log("After Getting Flight Details ===========> ", flightDetails);
  //   console.log("After Getting Actual Flight Details ===========> ", actualFlightDetails);
      



 
  // };


  // Flight Stats fetch option

  const [multiFlightOpened, { open: multiFlightOpen, close: multiFlightClose }] = useDisclosure(false);
  const [multiFlightData, setMultiFlightData] = useState([]);
  const [filteredFlightData, setFilteredFlightData] = useState(null);
  const [flightIndex, setFlightIndex] = useState(null);
 

    const fetchFlightOptions = async (index) => {
    const flight =
      triggerFrom === "actual"
        ? actualFlightDetails[index]
        : flightDetails[index];

    if (triggerFrom === "original") {
      if (
        !flight?.date_of_travel ||
        !flight?.hub_code ||
        !flight?.flight_number
      ) {
        Swal.fire({
          icon: "warning",
          title: "Missing Information",
          text: "Please fill in the original date of travel, airline, and flight number before proceeding!",
        });
        return;
      }
    } else if (triggerFrom === "actual") {
      // //console.log(
      //   "200",
      //   flight.actual_date_of_travel,
      //   flight.actual_hub_code,
      //   flight.actual_airline
      // );
      if (
        !flight?.actual_date_of_travel ||
        !flight?.actual_hub_code ||
        !flight?.actual_flight_number
      ) {
        Swal.fire({
          icon: "warning",
          title: "Missing Information",
          text: "Please fill in the actual date of travel, airline, and flight number before proceeding!",
        });
        return;
      }
    }

    // setbackdropopen(true);
    try {
      const response = await axios.post(
        `${base_url.api1}/tourapp/flight_states`,
        {
          airline_code:
            triggerFrom === "original"
              ? flight.hub_code
              : flight.actual_hub_code,
          flight_number:
            triggerFrom === "original"
              ? flight.flight_number
              : flight.actual_flight_number,
          flight_date:
            triggerFrom === "original"
              ? formatDOB(flight.date_of_travel)
              : formatDOB(flight.actual_date_of_travel),
        }
      );
      //console.log("triggerFrom 204", triggerFrom);
console.log(response)
      const flightOptionsData = response.data.Flight.map((flightData) => {
        const departureScheduled = flightData.departure.scheduled;
        const departureActual = flightData.departure.actual;
        const departureActualRunway = flightData.departure.actual_runway;
        const arrivalScheduled = flightData.arrival.scheduled;
        const arrivalActual = flightData.arrival.actual;

        const arrivalActualRunway = flightData.arrival.actual_runway;

        const departureEstimated = flightData.departure.estimated;
        const arrivalEstimated = flightData.arrival.estimated;
        const departureEstimatedRunway = flightData.departure.estimated_runway;
        const arrivalEstimatedRunway = flightData.arrival.estimated_runway;

        const delayDuration = getDelayDuration(arrivalScheduled, arrivalActual || arrivalActualRunway || arrivalEstimated || arrivalEstimatedRunway);
       console.log(delayDuration,departureActual,departureScheduled);
        return {
          value: `${flightData.departure.iata}-${flightData.arrival.iata}`,
          departure: {
            airport: flightData.departure.airport,
            iata: flightData.departure.iata,
            departureScheduled,
            timeZone:flightData.departure.timezone,
            departureActual :departureActual || departureActualRunway || departureEstimated || departureEstimatedRunway || departureScheduled,
          },
          arrival: {
            airport: flightData.arrival.airport,
            iata: flightData.arrival.iata,
            arrivalScheduled,
                        timeZone:flightData.arrival.timezone,

            arrivalActual :arrivalActual || arrivalActualRunway || arrivalEstimated || arrivalEstimatedRunway || arrivalScheduled,
          },
          delay_duration_minutes: delayDuration,
          label: `${flightData.arrival.airport} - ${flightData.departure.airport}`,
        };
      });

      

      if (flightOptionsData.length > 1) {
        console.log(response.data.Flight)
        setMultiFlightData(response.data.Flight?.map((f) => ({
          ...f,
          selected: false
        })));
        setFilteredFlightData(flightOptionsData);
        setFlightIndex(index);
        // setFlightOptionsData(flightOptionsData);
        multiFlightOpen();
        


        console.log(flightOptionsData)
return
      }

      const flightList = flightOptionsData[0]; // Get flight based on triggerIndex
     
      if (flightList) {
        const updatedFlightDetails =
          triggerFrom === "actual"
            ? [...actualFlightDetails]
            : [...flightDetails]; // Assuming flightDetails is a state variable.

        if (triggerFrom === "actual") {
          // const actualArrivalTime = flightList.arrival.arrivalActual || "";
          // const originalArrivalTime =
          //   updatedFlightDetails[triggerIndex].original_arrival_time || "";

          // let delay = "";
          // if (actualArrivalTime && originalArrivalTime) {
          //   delay = calculateDelay(actualArrivalTime, originalArrivalTime);
          //   setDelay(delay);
          // }

          updatedFlightDetails[triggerIndex] = {
            ...updatedFlightDetails[triggerIndex],
            actual_departure_time:
              flightList.departure.departureActual &&
              flightList.departure.departureActual !== null &&
              flightList.departure.departureActual !== undefined &&
              flightList.departure.departureActual !== "" &&
              flightList.departure.departureActual !== "+00:00"
                ? dateFormat(flightList.departure.departureActual,flightList.departure.timeZone)
                   
                    .time
                : "",
            actual_departure_date:
              flightList.departure.departureActual &&
              flightList.departure.departureActual !== null &&
              flightList.departure.departureActual !== undefined &&
              flightList.departure.departureActual !== "" &&
              flightList.departure.departureActual !== "+00:00"
                ?dateFormat(flightList.departure.departureActual,flightList.departure.timeZone)
                   
                    .date
                : "",
            actual_arrival_time:
              flightList.arrival.arrivalActual &&
              flightList.arrival.arrivalActual !== null &&
              flightList.arrival.arrivalActual !== undefined &&
              flightList.arrival.arrivalActual !== "" &&
              flightList.arrival.arrivalActual !== "+00:00"
                ? dateFormat( flightList.arrival.arrivalActual,flightList.arrival.timeZone)
                   
                    .time
                : "",
            actual_arrival_date:
              flightList.arrival.arrivalActual &&
              flightList.arrival.arrivalActual !== null &&
              flightList.arrival.arrivalActual !== undefined &&
              flightList.arrival.arrivalActual !== "" &&
              flightList.arrival.arrivalActual !== "+00:00"
                ?dateFormat( flightList.arrival.arrivalActual,flightList.arrival.timeZone)
                   
                    .date
                : "",

            actual_airport_of_origin: flightList.departure.airport || "",
            actual_airport_of_destination: flightList.arrival.airport || "",
            departure_iata_code: flightList.departure.iata || "",
            arrival_iata_code: flightList.arrival.iata || "",
            delay_duration_minutes: flightList.delay_duration_minutes || 0,
          };
        } else if (triggerFrom === "original") {
          // const originalArrivalTime = flightList.arrival.arrivalScheduled || "";
          // const actualArrivalTime =
          //   updatedFlightDetails[triggerIndex].actual_arrival_time || "";

          // let delay = "";
          // if (originalArrivalTime && actualArrivalTime) {
          //   delay = calculateDelay(actualArrivalTime, originalArrivalTime);
          //   setDelay(delay);
          // }

          updatedFlightDetails[triggerIndex] = {
            ...updatedFlightDetails[triggerIndex],
            airport_of_origin: flightList.departure.airport || "",
            airport_of_destination: flightList.arrival.airport || "",
            original_departure_time:
              flightList.departure.departureScheduled &&
              flightList.departure.departureScheduled !== null &&
              flightList.departure.departureScheduled !== undefined &&
              flightList.departure.departureScheduled !== "" &&
              flightList.departure.departureScheduled !== "+00:00"
                ? dateFormat( flightList.departure.departureScheduled,flightList.departure.timeZone)
                   
                    .time
                : "",
            original_departure_date:
              flightList.departure.departureScheduled &&
              flightList.departure.departureScheduled !== null &&
              flightList.departure.departureScheduled !== undefined &&
              flightList.departure.departureScheduled !== "" &&
              flightList.departure.departureScheduled !== "+00:00"
                ? dateFormat( flightList.departure.departureScheduled,flightList.departure.timeZone)
                   
                    .date
                : "",
            original_arrival_time:
              flightList.arrival.arrivalScheduled &&
              flightList.arrival.arrivalScheduled !== null &&
              flightList.arrival.arrivalScheduled !== undefined &&
              flightList.arrival.arrivalScheduled !== "" &&
              flightList.arrival.arrivalScheduled !== "+00:00"
                ? dateFormat( flightList.arrival.arrivalScheduled,flightList.arrival.timeZone)
                   
                    .time
                : "",
            original_arrival_date:
              flightList.arrival.arrivalScheduled &&
              flightList.arrival.arrivalScheduled !== null &&
              flightList.arrival.arrivalScheduled !== undefined &&
              flightList.arrival.arrivalScheduled !== "" &&
              flightList.arrival.arrivalScheduled !== "+00:00"
                ? dateFormat( flightList.arrival.arrivalScheduled,flightList.arrival.timeZone)
                   
                  .date
                
                : "",
            departure_iata_code: flightList.departure.iata || "",
            arrival_iata_code: flightList.arrival.iata || "",
            actual_departure_time:
              flightList.departure.departureActual &&
              flightList.departure.departureActual !== null &&
              flightList.departure.departureActual !== undefined &&
              flightList.departure.departureActual !== "" &&
              flightList.departure.departureActual !== "+00:00"
                ? dateFormat( flightList.departure.departureActual,flightList.departure.timeZone)
                   
                  .time
                : "",
            actual_departure_date:
              flightList.departure.departureActual &&
              flightList.departure.departureActual !== null &&
              flightList.departure.departureActual !== undefined &&
              flightList.departure.departureActual !== "" &&
              flightList.departure.departureActual !== "+00:00"
                ? dateFormat( flightList.departure.departureActual,flightList.departure.timeZone)
                   
                  .date
                : "",
            actual_arrival_time:
              flightList.arrival.arrivalActual &&
              flightList.arrival.arrivalActual !== null &&
              flightList.arrival.arrivalActual !== undefined &&
              flightList.arrival.arrivalActual !== "" &&
              flightList.arrival.arrivalActual !== "+00:00"
                ?dateFormat( flightList.arrival.arrivalActual,flightList.arrival.timeZone)
                   
                  .time
                : "",
            actual_arrival_date:
              flightList.arrival.arrivalActual &&
              flightList.arrival.arrivalActual !== null &&
              flightList.arrival.arrivalActual !== undefined &&
              flightList.arrival.arrivalActual !== "" &&
              flightList.arrival.arrivalActual !== "+00:00"
                ? dateFormat( flightList.arrival.arrivalActual,flightList.arrival.timeZone)
                   
                  .date
                : "",
            
            delay_duration_minutes: flightList.delay_duration_minutes || 0,
          };
        }

       
        if (triggerFrom === "actual") {
          setActualFlightDetails(updatedFlightDetails);
        } else {
          setFlightDetails(updatedFlightDetails);
        }
      }

      setTriggerIndex(null);

      const updatedFlightOptions = { ...flightOptions };
      updatedFlightOptions[index] = flightOptionsData;
      setFlightOptions(updatedFlightOptions);

      setbackdropopen(false);
    } catch (error) {
      console.error("Error fetching flight options:", error);
      setFlightOptions((prevState) => {
        const updatedFlightOptions = { ...prevState };
        updatedFlightOptions[index] = [];
        return updatedFlightOptions;
      });
      const updatedFlightDetails =
        triggerFrom === "actual"
          ? [...actualFlightDetails]
          : [...flightDetails];

      if (triggerFrom === "actual") {
        updatedFlightDetails[triggerIndex] = {
          ...updatedFlightDetails[triggerIndex],
          actual_departure_time: "",
          actual_arrival_time: "",
          actual_airport_of_origin: "",
          actual_airport_of_destination: "",
          delay: "",
          departure_iata_code: "",
          arrival_iata_code: "",
            delay_duration_minutes:  0,

        };
      } else if (triggerFrom === "original") {
        updatedFlightDetails[triggerIndex] = {
          ...updatedFlightDetails[triggerIndex],
          airport_of_origin: "",
          airport_of_destination: "",
          original_departure_time: "",
          original_arrival_time: "",
          departure_iata_code: "",
          arrival_iata_code: "",
            delay_duration_minutes:  0,

        };
      }

      if (triggerFrom === "actual") {
        setActualFlightDetails(updatedFlightDetails);
      } else {
        setFlightDetails(updatedFlightDetails);
      }

      setTriggerIndex(null);

      setbackdropopen(false);
    }

    console.log("After Getting Flight Details ===========> ", flightDetails);
    console.log("After Getting Actual Flight Details ===========> ", actualFlightDetails);
      



 
  };
 

  const addFlightDetails = () => {
    setTriggerIndex(null);
    setFlightDetails([
      ...flightDetails,
      {
        airline: "",
        flight_number: "",
        airport_of_origin: "",
        airport_of_destination: "",
        date_of_travel: "",
        original_departure_time: "",
        original_arrival_time: "",
        original_departure_date: "",
        original_arrival_date: "",
        original_departure: "",
        original_arrival: "",
        hub_code: "",
        iata_code:"",
      search_by:"airline_name",
flight_class:"Economy",

        // New fields for the enhanced form logic
        ticket_ref_no: "",
        disruption: "", // delayed, cancelled, missed
        delay_duration: "", // Less than 3 hours, 3–4 hours, 4+ hours
        flight_cancel: "", // Before arriving at the airport, At the airport
        missed_connection: "", // Flight delay, Airline error, Personal reasons
        // claim_details: "", // Any additional information provided by the user

        additional_details: "",

        delayed: false,
        cancelled: false,
        missed: false,
        denied: false,
        downgraded:false,
        cancellation_info_before: false,
        cancellation_info_at_airport: false,
        missed_due_to_error: false,
        missed_due_to_personal: false,
      },
    ]);
  };

  const addActualFlightDetails = () => {
    setTriggerIndex(null);
    setActualFlightDetails([
      ...actualFlightDetails,
      {
        actual_airline: "",
        actual_flight_number: "",
        actual_airport_of_origin: "",
        actual_airport_of_destination: "",
        actual_date_of_travel: "",
        actual_departure_time: "",
        actual_arrival_time: "",
        actual_departure_date: "",
        actual_arrival_date: "",
        
actual_flight_class:"Economy",

        actual_departure: "",
        actual_arrival: "",
        actual_hub_code: "",
        ticket_ref_no: "",
        provided_by_airline: false,
        self_booked: false,
        same_as_original: false,
      search_by:"airline_name",

      },
    ]);
  };

  const removeFlightDetails = (indexToRemove) => {
    setTriggerIndex(null);
    if (flightDetails.length > 1) {
      const updatedFlightDetails = [];

      flightDetails.forEach((flight, index) => {
        if (index != indexToRemove) {
          updatedFlightDetails.push(flight);
        } else if (flight.id) {
          setFlightRemoveIds((prev) => [...prev, flight.id]);
        }
      });

      setFlightDetails(updatedFlightDetails);
    }
  };

  const removeActualFlightDetails = (indexToRemove) => {
    setTriggerIndex(null);
    if (actualFlightDetails.length > 1) {
      const updatedFlightDetails = [];

      actualFlightDetails.forEach((flight, index) => {
        if (index != indexToRemove) {
          updatedFlightDetails.push(flight);
        } else if (flight.id) {
          setActualRemoveIds((prev) => [...prev, flight.id]);
        }
      });

      setActualFlightDetails(updatedFlightDetails);
    }
  };

  // const handleDelayChange = (e, index, type) => {
  //   setTriggerIndex(null);
  //   const updatedFlightDetails = [...flightDetails];
  //   let [hours, minutes] = updatedFlightDetails[index].delay.split(":");
  //   if (type === "hours") {
  //     hours = e.target.value;
  //   } else {
  //     minutes = e.target.value;
  //   }
  //   // Update the delay as "HH:MM"
  //   updatedFlightDetails[index].delay = `${hours || "00"}:${minutes || "00"}`;
  //   setFlightDetails(updatedFlightDetails);
  // };

  const handleTermsLinkClick = () => {
    setIsTermsLinkClicked(true);
  };

  const handleSignatureAdded = (signatureData) => {
    ////console.log("ok");
  };

  const handlePdfGenerated = (blob) => {
    setPdfBlob(blob);
    setSignatureCaptured(true); // Set state to show "View Agreement" button
  };

  // const handleTermsChange = () => {
  //   setIsTermsChecked(!isTermsChecked);
  // };

  const handleAgreementChange = (event) => {
    //console.log("574---------->", event.target.checked);

    if (isAgreementLinkClicked) {
      setIsAgreementChecked(event.target.checked);
      //console.log("578---------->", event.target.checked);
    } else {
      event.preventDefault();
      Swal.fire({
        title: "Please read the Agreement",
        text: "You must click on the Agreement link and read them before checking the checkbox.",
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
  };

  const handlePowerOfAttorneyChange = (event) => {
    if (isPowerLinkClicked) {
      setIsPowerOfAttorneyChecked(event.target.checked);
    } else {
      event.preventDefault();
      Swal.fire({
        title: "Please read the Power of Attorney",
        text: "You must click on the Power of Attorney link and read it before proceeding.",
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
  };

  // const fetchSignedDocument = () => {
  //   setbackdropopen(true);

  //   // const sign_url = `${base_url.api1}/tourapp/get_signed_doc?id=${envolpeId}`;
  //   const sign_url = `${base_url.api1}/tourapp/wesign_signed_doc?id=${envolpeId}`;

  //   axios
  //     .get(sign_url)
  //     .then((response) => {
  //       if (response.data && response.data.Document) {
  //         const document_url = response.data.Document;
  //         //console.log("Document URL", document_url);
  //         let pdfBlob = null;
  //         setbackdropopen(true);
  //         fetch(document_url)
  //           .then((pdfResponse) => {
  //             if (!pdfResponse.ok) {
  //               throw new Error("Failed to fetch the document.");
  //             }
  //             //console.log("Finally 1");
  //             return pdfResponse.blob();
  //           })
  //           .then((blob) => {
  //             //console.log("Finally 2", blob);
  //             pdfBlob = blob;
  //             setPdfBlob(pdfBlob);
  //             setSignatureCaptured(true);
  //             setDocumentFetched(true);
  //           })
  //           .catch((error) => {
  //             console.error("Error fetching or converting PDF:", error);
  //           });
  //         // pdfBlob = base64ToBlob(document_url, "application/pdf");
  //         // setPdfBlob(pdfBlob);
  //         // setSignatureCaptured(true);
  //         // setDocumentFetched(true);
  //       } else {
  //         console.error("Signed document is not present in the response.");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching signed document:", error);
  //     })
  //     .finally(() => {
  //       //console.log("Finally 3");
  //       setbackdropopen(false);
  //     });
  // };

  // const startFetching = () => {
  //   if (intervalId) clearInterval(intervalId);
  //   const id = setInterval(() => {
  //     if (!isFetching) {
  //       fetchSignedDocument();
  //     }
  //   }, 10000);
  //   setIntervalId(id);
  // };

  // useEffect(() => {
  //   if (envolpeId && !documentFetched) {
  //     startFetching();
  //   }
  //   return () => {
  //     if (intervalId) clearInterval(intervalId);
  //   };
  // }, [envolpeId, isFetching, documentFetched]);

  // const handleReFetch = () => {
  //   setDocumentFetched(false);
  //   startFetching();
  // };

  const fetchSignedDocument = async () => {
    try {
      setbackdropopen(true);
      // const sign_url = `${base_url.api1}/tourapp/get_signed_doc?id=${envolpeId}`;
      const sign_url = `${base_url.api1}/tourapp/wesign_signed_doc_new?id=${envolpeId}`;

      const response = await axios.get(sign_url);

      console.log(response)
      if (response?.data && response?.data?.status_code === 200) {
         setIsAgreementLinkClicked(true);
      }
      if (response.data && response.data.Document) {
        const document_url = response.data.Document;

        const pdfResponse = await fetch(document_url);

        if (!pdfResponse.ok) {
          throw new Error("Failed to fetch the document.");
        }

        const pdfBlob = await pdfResponse.blob();

        setPdfBlob(pdfBlob);
        setSignatureCaptured(true);
        setDocumentFetched(true);
       
      } else {
        console.error("Signed document is not present in the response.");
       

      }
    } catch (error) {
      console.error("Error fetching signed document:", error);
       

    } finally {
      //console.log("Completed fetching the document.");
      setbackdropopen(false);
       

    }
  };

  const handleIframeClose = () => {
    fetchSignedDocument();
  };

  const isFormValid =
    isTermsChecked &&
    isAgreementChecked &&
    (familyMembers.length > 0 ? isPowerOfAttorneyChecked : true);

  const handleInputChange = (e, index, fieldName) => {
    const { value } = e.target;
    setFamilyMembers((prevMembers) => {
      const updatedMembers = [...prevMembers];
      updatedMembers[index] = {
        ...updatedMembers[index],
        [fieldName]: value,
      };
      return updatedMembers;
    });
  };

  const addAdditionalClaim = () => {
    openAdditionalClaim();
  };
  const addAdditionalData = () => {
    setAdditionalClaimData((prev) => [
      ...prev,
      {
        claim_type: "",
        claim_explanation: "",
        amount: "",
        other_claim_doc: null,
        currency_type: "usd",
        other_claim_doc_name: null,
      },
    ]);

    setAdditionalClaimValidation((prev) => [
      ...prev,
      {
        claim_type: false,
        amount: false,
        claim_explanation: false,
        other_claim_doc: false,
      },
    ]);
  };

  const removeAdditionalData = (indexToRemove) => {
    const updatedClaimData = [];

    additionalClaimData.forEach((claim, index) => {
      if (index != indexToRemove) {
        updatedClaimData.push(claim);
      } else if (claim.id) {
        setOtherclaimRemoveIds((prev) => [...prev, claim.id]);
      }
    });

    setAdditionalClaimData(updatedClaimData);
    if (updatedClaimData.length == 0) {
      addAdditionalData();
    }
  };

  const addFamilyMember = () => {
    setFamilyMembers([
      ...familyMembers,
      {
        first_name: null,
        last_name: null,
        date_of_birth: null,
        passport_number: null,
        tickets: null,
        country: "United States",
        passport: null, // Initialize as null or handle file object
        passport_name: null,
        additional_doc: null,
        additionalDoc_name: null,
        boarding_pass: null, // Initialize as null or handle file object
        boardingpass_name: null,
        airline_res_no: null,
      },
    ]);
  };
  const [ticketNumberErrors, setTicketNumberErrors] = useState(
    Array(familyMembers.length).fill("")
  );

  const handleTicketNumberChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "");
    let errorMessage = "";
    if (value.length > 13) {
      return;
    }

    if (!value) {
      errorMessage = "Ticket Number is Required";
    } else if (value.length !== 13) {
      errorMessage = "Ticket Number must be 13 digits";
    }
    const updatedErrors = [...ticketNumberErrors];
    updatedErrors[index] = errorMessage;
    setTicketNumberErrors(updatedErrors);

    setFamilyMembers((prevMembers) => {
      const updatedMembers = [...prevMembers];
      updatedMembers[index] = {
        ...updatedMembers[index],
        tickets: value,
      };
      return updatedMembers;
    });
  };

  const handlePassportUpload = (e, index) => {
    const file = e.target.files[0];
    const updatedFamilyMember = [...familyMembers];

    updatedFamilyMember[index]["passport"] = file;
    updatedFamilyMember[index]["passport_name"] = `passport_${index + 1}`;
    updatedFamilyMember[index]["passport_file_name"] = file.name;
    setFamilyMembers(updatedFamilyMember);
  };

  const handleAdditionalUpload = (e, index) => {
    const file = e.target.files[0];
    const updatedFamilyMember = [...familyMembers];
    updatedFamilyMember[index]["additional_doc"] = file;
    updatedFamilyMember[index]["additionalDoc_name"] = `sub_doc_claim_${
      index + 1
    }`;
    updatedFamilyMember[index]["addtional_file_name"] = file.name;

    setFamilyMembers(updatedFamilyMember);
  };

  const handleBoardingUpload = (e, index) => {
    const file = e.target.files[0];
    const updatedFamilyMember = [...familyMembers];
    updatedFamilyMember[index]["boarding_pass"] = file;
    updatedFamilyMember[index]["boardingpass_name"] = `boarding_pass_${
      index + 1
    }`;
    updatedFamilyMember[index]["boarding_pass_file_name"] = file.name;

    setFamilyMembers(updatedFamilyMember);
  };

  const removeFamilyMember = (indexToRemove) => {
    const updatedFamilyMembers = [];
    familyMembers.forEach((member, index) => {
      if (index !== indexToRemove) {
        updatedFamilyMembers.push(member);
      } else if (member.id) {
        setSubclaimRemoveIds((prev) => [...prev, member.id]);
      }
    });

    setFamilyMembers(updatedFamilyMembers);
  };

  const getCurrentDateTime = () => {
    return moment().format("h:mm A MMMM D, YYYY");
  };

  const addCustomerNote = (customerNote, notes) => {
    const trimmedNote = customerNote?.trim();

    // Don't add the note if it's empty, null, or only contains spaces
    if (!trimmedNote) {
      return notes ? notes : null;
    }

    const dateTime = getCurrentDateTime();
    const newNote = {
      user: "customer",
      note: trimmedNote,
      timestamp: dateTime,
    };

    return notes ? [newNote, ...notes] : [newNote];
  };

  const fetchSuggestions = async (inputValue) => {
    if (!inputValue) {
      setOptionsList([]);
      setIsAddressDropdownOpen(false);
      return;
    }

    try {
      const response = await axios.get(
        `${base_url.api1}/tourapp/address_suggestion?address=${inputValue}`
      );
      const data = response.data;
      const suggestions = data.suggestions.map((suggestion) => ({
        label: suggestion.postal_code
          ? `${suggestion.description},${suggestion.postal_code}`
          : suggestion.description,
        value: suggestion.place_id,
      }));
      setOptionsList(suggestions);
      setIsAddressDropdownOpen(true);

      console.log(suggestions);
    } catch (error) {
      console.error("Error fetching suggestions:", error);
      setOptionsList([]);
      setIsAddressDropdownOpen(false);
    }
  };

  const [mobile, setMobile] = useState();
  const [ticket, setTicket] = useState();

  const handleTicketInputChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
    if (value.length > 13) {
      return;
    }
    setTicket(value);
    setValue("tickets", value, { shouldValidate: true });
  };

  const handleMobileInputChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
    if (value.length > 10) {
      return;
    }
    setMobile(value);
    setValue("contact_no", value, { shouldValidate: true });
  };

  const [addressQuery, setAddressQuery] = useState("");
  const handleAddressInputChange = (e) => {
    setAddressQuery(e.target.value);
    setValue("address", e.target.value);
    setIsOpenList(true);
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (addressQuery.length > 2) {
        fetchSuggestions(addressQuery);
        setIsOpenList(true);
      } else {
        setOptionsList([]);
        setIsOpenList(false);
      }
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [addressQuery]);

  const handleClickAddressDropdown = (value) => {
    setValue("address", value);
    setIsAddressDropdownOpen(false);
  };
  const handleAddressChange = (option) => {
    setValue("address", option.label);
    setOptionsList([]);
    setIsOpenList(false);
  };
  const handleInputBlur = () => {
    setTimeout(() => {
      setIsOpenList(false);
    }, 100);
  };

  const handleHourChange = (event) => {
    setSelectedHour(event.target.value);
    ////console.log(event.target.value);
    setHourStatus(false);
  };

  const handleMinuteChange = (event) => {
    setSelectedMinute(event.target.value);
    ////console.log(event.target.value);
    setMinStatus(false);
  };

  useEffect(() => {
    try {
       const lastFlightDetail = flightDetails[flightDetails?.length - 1];
    const lastActualFlightDetail =
      actualFlightDetails[actualFlightDetails?.length - 1];

    if (
      lastFlightDetail?.original_arrival_time &&
      lastFlightDetail?.original_arrival_date &&
      lastActualFlightDetail?.actual_arrival_time &&
      lastActualFlightDetail?.actual_arrival_date
    ) {
      const originalArrivalDateTime = `${lastFlightDetail.original_arrival_date}T${lastFlightDetail.original_arrival_time}`;
      const actualArrivalDateTime = `${lastActualFlightDetail.actual_arrival_date}T${lastActualFlightDetail.actual_arrival_time}`;

      const delay = calculateDelay(
        actualArrivalDateTime,
        originalArrivalDateTime
      );
      setDelay(delay);
    } else {
      setDelay("HH:MM");
    }
    } catch (error) {
      setDelay("HH:MM")
    }
   
  }, [flightDetails, actualFlightDetails]);

  // Fetch initial data
  useEffect(() => {
    fetchEmail();
    fetchInitialAirports();
  }, []);

  const fetchEmail = async () => {
    try {
      const response = await axios.get(
        `${base_url.api1}/tourapp/get_flyandClaim_email`
      );

      // //console.log("798-->", response?.data?.Email);
      setEmail(response?.data?.Email);
    } catch (error) {
      //console.log("798-->", error);
    }
  };

  const fetchAirlines = async (inputValue,search_by) => {
  if (inputValue.length === 0) return [];

  try {
    const response = await axios.get(
      `${base_url.api1}/tourapp/flight_states_airlines?${search_by}=${inputValue}`
    );

    if (!response.data || !response.data.Airlines) return [];

    const airlines = response.data.Airlines.map((airline) => ({
      value: airline.id,
      label: `${airline.airline_name} ${
        airline.iata_code ? `(${airline.iata_code})` : ""
      }`,
      airline_name: airline?.airline_name || "",
      iata_code: airline?.iata_code || "",
    
            hub_code: airline.icao_code,
    }));

    const search = inputValue.toLowerCase();

    // 1️⃣ EXACT MATCH
    const exact = airlines.filter((a) =>
      a.iata_code.toLowerCase() === search ||
      a.airline_name.toLowerCase() === search
    );

    // 2️⃣ STARTS WITH
    const startsWith = airlines.filter((a) =>
      (a.iata_code.toLowerCase().startsWith(search) ||
       a.airline_name.toLowerCase().startsWith(search)) &&
      !(a.iata_code.toLowerCase() === search ||
        a.airline_name.toLowerCase() === search)
    );

    // 3️⃣ CONTAINS ANYWHERE
    const contains = airlines.filter((a) =>
      (a.iata_code.toLowerCase().includes(search) ||
       a.airline_name.toLowerCase().includes(search)) &&
      !(
        a.iata_code.toLowerCase().startsWith(search) ||
        a.airline_name.toLowerCase().startsWith(search)
      )
    );

    return [...exact, ...startsWith, ...contains];
  } catch (error) {
    console.error("Error fetching airlines:", error);
    return [];
  }
};

  // const fetchAirlines = async (inputValue,search_by) => {
  //   if (inputValue.length > 0) {
  //     try {
  //       const response = await axios.get(
  //         `${base_url.api1}/tourapp/flight_states_airlines?${search_by}=${inputValue}`
  //       );
  //       if (response.data && response.data.Airlines) {
  //         return response.data.Airlines.map((airline) => ({
  //           value: airline.id,
  //           label: `${airline.airline_name} ${
  //             airline.iata_code ? `(${airline.iata_code})` : ""
  //             }`,
  //           iata_code:airline.iata_code || "",
  //           hub_code: airline.icao_code,
  //         }));
  //       }
  //     } catch (error) {
  //       console.error("Error fetching airlines:", error);
  //     }
  //   }
  //   return [];
  // };

  const fetchHomeSuggestions = async (inputValue) => {
    if (inputValue.length > 0) {
      try {
        const response = await axios.get(
          `${base_url.api1}/tourapp/address_suggestion?address=${inputValue}`
        );
        const data = response.data;
        return data.suggestions.map((suggestion) => ({
          label: suggestion.description,
          value: suggestion.description,
        }));
      } catch (error) {
        console.error("Error fetching suggestions:", error);
        return [];
      }
    }
  };

  const handleAdditionalFileChange = (e) => {
    console.log(e)
    console.log(e.target.files)
    setSelectedAdditionalFiles(e.target.files);
  };

    const handleLuggageFileChange = (e) => {
    setSelectedLuggageFiles(e.target.files);
  };

  const loadOptions = (inputValue, callback) => {
    fetchAirports(inputValue).then((options) => callback(options));
  };

  const fetchAirports = async (inputValue) => {
    if (inputValue.length > 0) {
      try {
        const response = await axios.get(
          `${base_url.api1}/tourapp/flight_states_airports?search=${inputValue}&sortby=airport_name`
        );
        if (response.data && response.data.Airports) {
          return response.data.Airports.map((airport) => ({
            value: airport.id,
            label: `${airport.airport_name.replace(
              /[\n\u0000-\u001F\u007F-\u009F]/g,
              ""
            )} (${airport.iata_code})`,
          }));
        }
      } catch (error) {
        console.error("Error fetching airports:", error);
      }
    }
    return [];
  };


  const loadAirlineOptions = (inputValue,search_by, callback) => {
    fetchAirlines(inputValue,search_by).then((options) => callback(options));
  };

  const fetchInitialAirports = async () => {
    try {
      // Fetch initial airline options
      const airlineResponse = await axios.get(
        `${base_url.api1}/tourapp/flight_states_airlines?sortby=airline_name`
      );
      if (airlineResponse.data && airlineResponse.data.Airlines) {
        const airlineOptions = airlineResponse.data.Airlines.map((airline) => ({
          value: airline.id,
          label: `${airline.airline_name} ${
            airline.iata_code ? `(${airline.iata_code})` : ""
          }`,
          hub_code: airline.iata_code,
        }));
        setDefaultAirlineOptions(airlineOptions);
      }

      const response = await axios.get(
        `${base_url.api1}/tourapp/flight_states_airports?sortby=airport_name`
      );
      if (response.data && response.data.Airports) {
        const options = response.data.Airports.map((airport) => ({
          value: airport.id,
          label: `${airport.airport_name.replace(
            /[\n\u0000-\u001F\u007F-\u009F]/g,
            ""
          )} (${airport.iata_code})`,
        }));

        setDefaultOptions(options);
      }
    } catch (error) {
      console.error("Error fetching initial airports:", error);
    }
  };

  const [pdfData, setPdfData] = useState(null);

  const [isAgreementModalOpen, setAgreementModalOpen] = useState(false);
  const [isPowerModalOpen, setIsPowerModalOpen] = useState(false);
  const [powerPdf, setPowerPdf] = useState(null);

  const openAgreementModal = () => {
    
    setAgreementModalOpen(true);
  };

  const [signers, setSigners] = useState([]);
  const [isPowerOfAttorneyFetchedErrorModal, setIsPowerOfAttorneyFetchedErrorModal] = useState(false);
  

  const getPowerOfAttorney = async () => {
    setIsPowerOfAttorneyFetchedErrorModal(false);
    const content = powerRef.current;
    let htmlString = null;

    if (content) {
      htmlString = content.innerHTML;
    }
    setbackdropopen(true);

    const signers = familyMembers.map((claim, index) => ({
      name: `${claim.first_name.toUpperCase()} ${claim.last_name.toUpperCase()}`,
      email_id: `flyandclaim${index}@gmail.com`,
    }));


      const controller = new AbortController();
  const TIMEOUT_MS = 30000; // 15 seconds

  // auto-abort after TIMEOUT_MS
  const timeoutId = setTimeout(() => {
    controller.abort();
     setIsPowerOfAttorneyFetchedErrorModal(true);
    setbackdropopen(false);
  }, TIMEOUT_MS);

    try {
      const response = await axios.post(
        `${base_url.api1}/tourapp/power_of_attorney_latest`,
        {
          html_string: htmlString,
          signers: signers,
        }
      );

      clearTimeout(timeoutId);

      if (response.data && response.data.status && response.data.document) {
        setSigners(response.data.signers || []);
        //console.log("Power of Attorney PDF fetched successfully.");
        const base64PDF = response.data.document;
        handlePowerPDF(base64PDF);
        setbackdropopen(false);
      } else {


        console.error("Failed to fetch Power of Attorney PDF.");
        setbackdropopen(false);
        setIsPowerOfAttorneyFetchedErrorModal(true);
      }
    } catch (error) {
      
      clearTimeout(timeoutId);
   // Detect abort/timeout
    const isAbort =
      error?.code === "ERR_CANCELED" || // axios recent cancellation code
      error?.name === "CanceledError" || // some axios builds
      error?.message?.toLowerCase().includes("aborted") ||
      error?.message?.toLowerCase().includes("canceled");

    if (isAbort) {
      console.warn("Request aborted due to timeout (>= 15s).");
    } else {
      console.error("Error fetching Power of Attorney PDF:", error);
    }
      setbackdropopen(false);
      setIsPowerOfAttorneyFetchedErrorModal(true);
    } finally {
      clearTimeout(timeoutId);

      setbackdropopen(false);

    }











  };
  const [poaPdf, setPoaPdf] = useState(null);
  const attorneyRef = useRef(null);

  const clearPoaAndAgreement = () => {
    setPoaPdf(null);
    setIsTermsChecked(false);
    setIsAgreementChecked(false)
    setIsPowerOfAttorneyChecked(false)
    setPdfBlob(null)
    setSignatureCaptured(false)
    setIsTermsLinkClicked(false)
    setIsAgreementLinkClicked(false)
    setIsPowerLinkClicked(false)
      
  }
  const handlePowerPDF = (base64PDF) => {
    const pdfBlob = base64ToBlob(base64PDF, "application/pdf");

    setPowerPdf(pdfBlob);
    setPoaPdf(pdfBlob);

    // const poaPdfUrl =  URL.createObjectURL(pdfBlob);
    // setPdfUrl(poaPdfUrl);
    // setTimeout(() => {

    // }, 1000); // Delay to ensure the modal opens after the PDF is ready

    // window.open(pdfUrl, "_blank");
  };

  // useEffect(() => {
  //   if (pdfUrl) {
  //     attorneyRef.current.click();
  //   }
  // }, [pdfUrl]);

  const base64ToBlob = (base64, contentType) => {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  };
  // Please review the Power of Attorney document carefully. 
        // Ensure you obtain consent from all other travelers listed. 
        // After obtaining their signatures, kindly send the completed document to 
        // <a href="mailto:claims@flyandclaim.com">${email}</a> 
        // for further processing of your claim.
  const openPowerOfAttorneyModal = () => {
    Swal.fire({
      title: "Important: Power of Attorney",
      html: `
      Please print and have all signatures completed. Email back document to <a href="mailto:claims@flyandclaim.com">claims@flyandclaim.com</a>  or access your claim from our website to sign the documents electronically.
      
      `,
      icon: "warning",
      confirmButtonText: "OK",
    }).then(() => {
      // Code to execute after the user clicks "OK"
      setIsPowerLinkClicked(true);
      // setIsPowerModalOpen(true);
      getPowerOfAttorney();
    });
  };

  const closePowerModal = () => setIsPowerModalOpen(false);
  const closeAgreementModal = () => setAgreementModalOpen(false);

  const handleCheckAgreement = () => {
    const formData = watch(); // Get current form data
    const todayDate = moment().format("DD-MM-YYYY");

    // Check required form fields
    // if (
    //   !getformData?.travelerInfo?.first_name ||
    //   !getformData?.travelerInfo?.last_name ||
    //   !getformData?.travelerInfo?.address ||
    //   !getformData?.travelerInfo?.passport_number ||
    //   !getformData?.travelerInfo?.contact_no ||
    //   !getformData?.travelerInfo?.date_of_birth ||
    //   !getformData?.travelerInfo?.tickets ||
    //   !getformData?.travelerInfo?.num_of_passenger ||
    //   !getformData?.travelerInfo?.postal_code ||
    //   !getformData?.travelerInfo?.state ||
    //   !getformData?.travelerInfo?.city
    // ) {
    //   Swal.fire({
    //     icon: "warning",
    //     title: "Incomplete Form",
    //     text: "Please fill in all required fields before agreeing to the terms.",
    //   });
    //   return false;
    // }

    // Check Flight  details
    // if (flightDetails.length > 0) {
    //   const incompleteFlightDetails = flightDetails.filter(
    //     (flight) =>
    //       !flight.airline ||
    //       !flight.flight_number ||
    //       !flight.airport_of_origin ||
    //       !flight.airport_of_destination ||
    //       !flight.date_of_travel
    //   );

    //   if (incompleteFlightDetails.length > 0) {
    //     Swal.fire({
    //       icon: "warning",
    //       title: "Incomplete Flight Details",
    //       text: "Please fill in all required flight details before agreeing to the terms.",
    //     });
    //     return false;
    //   }
    // }

    // Check family members' details
    // if (familyMembers.length > 0) {
    //   const incompleteFamilyMembers = familyMembers.filter(
    //     (member) =>
    //       !member.first_name ||
    //       !member.last_name ||
    //       !member.date_of_birth ||
    //       !member.passport_number ||
    //       !member.tickets
    //   );

    //   if (incompleteFamilyMembers.length > 0) {
    //     Swal.fire({
    //       icon: "warning",
    //       title: "Incomplete Travelers Details",
    //       text: "Please fill in all required travelers details before agreeing to the terms.",
    //     });
    //     return false;
    //   }
    // }

    // If all checks pass, proceed with storing the data
    const dataToStore1 = {
      date: todayDate,
      clientName: `${
        getformData?.travelerInfo?.first_name ?? claimData?.first_name
      } ${getformData?.travelerInfo?.last_name ?? claimData?.last_name}`,
      clientAddress: getformData?.travelerInfo?.address ?? claimData?.address,
      passportNumber:
        getformData?.travelerInfo?.passport_number ??
        claimData?.passport_number,
      clientEmail: `${
        getformData?.travelerInfo?.email_id ?? claimData?.email_id
      }`,
      bookingNumber: `${
        getformData?.travelerInfo?.contact_no ?? claimData?.contact_no
      }`,
      clientBirthDate: `${
        formatDOB(getformData?.travelerInfo?.date_of_birth) ??
        formatDOB(claimData?.date_of_birth)
      }`,
      familyMembers: familyMembers, // Pass the familymember array here
      flightDetails: flightDetails,
      clientTicketNumber:
        getformData?.travelerInfo?.tickets ?? claimData?.tickets,
    };

    setDataToStore(dataToStore1);

    //console.log("hello", dataToStore);

    return true;
  };

  const handleCheckPowerOfAttorney = () => {
    return handleCheckAgreement();
  };

  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (selectedDate) => {
    if (selectedDate) {
      const formattedDate = selectedDate.toLocaleDateString();
      //console.log("Selected Date:", formattedDate);
      setValue("date_of_birth", formattedDate); // Update form value
      setIsOpen(false); // Close the date picker
    }
  };

  const [geteligible, seteligible] = useState();
  const [getclaimid, setclaimid] = useState();
  const [claimObjId, setClaimObjeId] = useState();


  const getFlightDetailsFromOriginal = () => {

    let formattedActualFlightDetails;
    if (isFlightProvided === "yes") {
      
  formattedActualFlightDetails = actualFlightDetails.map((flight,index) => {
      const flightData = {
        actual_departure: `${formatDOB(flight.actual_date_of_travel)}T${
          flight.actual_departure_time?.trim()
            ? flight.actual_departure_time
            : "00:00"
        }`,

        actual_arrival: `${formatDOB(flight.actual_arrival_date)}T${
          flight.actual_arrival_time?.trim()
            ? flight.actual_arrival_time
            : "00:00"
        }`,
        actual_airport_of_origin: flight.actual_airport_of_origin,
        actual_date_of_travel: formatDOB(flight.actual_date_of_travel),
        actual_airport_of_destination: flight.actual_airport_of_destination,
        actual_airline: flight.actual_airline,
        actual_flight_number: flight.actual_flight_number,
        provided_by_airline: flight.provided_by_airline,
        self_booked: flight.self_booked,
        ticket_ref_no: flight.ticket_ref_no,
         airline_code:flight?.actual_hub_code,
        actual_flight_class: flight.actual_flight_class,
        sequence:index+1
      };
      if (isClaimId) {
        if (flight.id !== null) {
          flightData.id = flight.id;
        }
      }

      return flightData;
    });
    } else if(isFlightProvided === "no") {



        formattedActualFlightDetails = flightDetails.map((flight,index) => {
      const flightData = {
        actual_departure: `${formatDOB(flight.actual_departure_date)}T${
          flight.actual_departure_time?.trim()
            ? flight.actual_departure_time
            : "00:00"
        }`,

        actual_arrival: `${formatDOB(flight.actual_arrival_date)}T${
          flight.actual_arrival_time?.trim()
            ? flight.actual_arrival_time
            : "00:00"
        }`,
        actual_airport_of_origin: flight.airport_of_origin,
        actual_date_of_travel: formatDOB(flight.actual_departure_date),
        actual_airport_of_destination: flight.airport_of_destination,
        actual_airline: flight.airline,
        actual_flight_number: flight.flight_number,
        provided_by_airline: null,
        self_booked: true,
        ticket_ref_no: null,
         airline_code:flight?.hub_code,

        actual_flight_class: flight.flight_class,
        sequence:index+1

      };
      if (isClaimId) {
        if (flight.id !== null) {
          flightData.id = flight.id;
        }
      }

      return flightData;
    });




    
    } else {
      formattedActualFlightDetails = []
    }
   


   
    console.log("Actual flight Details from Original",formattedActualFlightDetails)
    return formattedActualFlightDetails
    
    
    

  }

  
  function formatDurationHHMM(minutes) {
    if (minutes === null || minutes === undefined || isNaN(minutes)) {
      return null;
    }
  console.log(minutes)
  const sign = minutes < 0 ? "-" : "";
  const absMinutes = Math.abs(minutes);
  const hours = Math.floor(absMinutes / 60);
  const mins = absMinutes % 60;
  console.log(`${sign}${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`)
  return `${sign}${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
}
  const getNewDelayDuration = (formatHHMM=false) => {
    let delay = 0
    try {
       if (isFlightProvided === "yes") {
      
      
         const orignalArrivalDate = formatDOB(flightDetails.at(-1).original_arrival_date)+"T"+flightDetails.at(-1).original_arrival_time
          const actualArrivalDate = formatDOB(actualFlightDetails.at(-1).actual_arrival_date)+"T"+actualFlightDetails.at(-1).actual_arrival_time
              

      console.log(flightDetails,actualFlightDetails)
      console.log(orignalArrivalDate,actualArrivalDate)
      
      delay = getDelayDuration(orignalArrivalDate, actualArrivalDate);

      



    } else {
       const orignalArrivalDate = formatDOB(flightDetails.at(-1).original_arrival_date)+"T"+flightDetails.at(-1).original_arrival_time
          const actualArrivalDate = formatDOB(flightDetails.at(-1).actual_arrival_date)+"T"+flightDetails.at(-1).actual_arrival_time
              
 console.log(flightDetails,actualFlightDetails)
      console.log(orignalArrivalDate,actualArrivalDate)
      
      delay = getDelayDuration(orignalArrivalDate, actualArrivalDate);

      


    }
    } catch(e) {
      console.log(e)
      return formatHHMM ? null :0
    }
   
    
    console.log(delay)
    return formatHHMM ? formatDurationHHMM(delay):delay
  }


  const onSubmit = (note) => {
    ////console.log("Img--->", selectedPassportSubClaim);
    ////console.log("Form Data", data);

    if (!pdfBlob) {
      Swal.fire({
        icon: "error",
        title: "Agreement need to be signed",
      });
      return;
    }

    if (!country1) {
      setCountryValid(true);
      return;
    }

    // let timeValue = "";
    // if (selectedHour && selectedMinute) {
    //   timeValue = `${selectedHour}:${selectedMinute}`;

    // }

    // let delay = timeValue;
    const formData = new FormData();

 

    const updatedNotes = addCustomerNote(note, previousNote);

    const additionalClaimDataPayload = [];
    additionalClaimData.forEach((claim, index) => {
      if (claim.other_claim_doc) {
        const claimData = {
          claim_type: claim.claim_type === "" ? null : claim.claim_type,
          claim_explanation:
            claim.claim_explanation === "" ? null : claim.claim_explanation,
          amount: claim.amount === "" ? null : claim.amount,
          currency_type: claim.currency_type,
        };

        claimData.other_claim_doc = claim.other_claim_doc_name;
        formData.append(claim.other_claim_doc_name, claim.other_claim_doc);

        if (isClaimId) {
          if (claim.id !== null) {
            claimData.id = claim.id;
          }
        }
        additionalClaimDataPayload.push(claimData);
      }
    });

    console.log(familyMembers);
    const familyMembersData = familyMembers.map((member, index) => {
      const memberData = {
        first_name: member?.first_name?.trim(),
        last_name: member.last_name,
        date_of_birth: formatDOB(member.date_of_birth),
        passport_number: member.passport_number,
        tickets: member.tickets,
        country: member.country,
        airline_res_no: member.airline_res_no,
      };

      if (member.passport && member.passport_name) {
        memberData.passport = member.passport_name;
        formData.append(member.passport_name, member.passport);
      }
      if (member.additional_doc && member.additionalDoc_name) {
        memberData.additional_doc = member.additionalDoc_name;
        formData.append(member.additionalDoc_name, member.additional_doc);
      }
      if (member.boarding_pass && member.boardingpass_name) {
        memberData.boarding_pass = member.boardingpass_name;
        formData.append(member.boardingpass_name, member.boarding_pass);
      }
      if (isClaimId) {
        if (member.id !== null) {
          memberData.id = member.id;
        }
      }

      return memberData;
    });
    const formattedFlightDetails = flightDetails.map((flight,index) =>
    {


      
      const flightData = {
        airline: flight.airline,
        airline_code:flight?.hub_code,
        flight_number: flight.flight_number,
        airport_of_origin: flight.airport_of_origin,
        airport_of_destination: flight.airport_of_destination,
        scheduled_arrival: `${formatDOB(flight.original_arrival_date)}T${
          flight.original_arrival_time &&
          flight.original_arrival_time.trim() !== ""
            ? flight.original_arrival_time
            : "00:00"
        }`,
        scheduled_departure: `${formatDOB(flight.date_of_travel)}T${
          flight.original_departure_time &&
          flight.original_departure_time.trim() !== ""
            ? flight.original_departure_time
            : "00:00"
        }`,
        date_of_travel: formatDOB(flight.date_of_travel),
        disruption: flight.delayed
          ? "delayed"
          : flight.cancelled
          ? "cancelled"
          : flight.missed
          ? "missed"
          : flight.denied
          ? "denied"
          : flight.downgraded
          ? "downgraded"
          : flight.disruption,
        delay_duration: flight.delay_duration === "none" ? null:flight.delay_duration,
        delay_cal:flight.delay_duration_minutes || 0,
        flight_cancel: flight.flight_cancel,
        missed_connection: flight.missed_connection ,
        // claim_details: flight.claim_details,
        additional_details: flight.additional_details,
        ticket_ref_no: flight.ticket_ref_no,
        delayed: flight.disruption === "delayed",
        cancelled: flight.disruption === "cancelled",
        missed: flight.disruption === "missed",
        denied: flight.disruption === "denied",
        downgraded: flight.disruption === "downgraded",
        cancellation_info_before: flight.cancellation_info_before,
        cancellation_info_at_airport: flight.cancellation_info_at_airport,
        missed_due_to_error: flight.missed_due_to_error,
        missed_due_to_personal: flight.missed_due_to_personal,
        flight_class: flight.flight_class,
        sequence:index+1
      };

      if (isClaimId) {
        if (flight.id !== null) {
          flightData.id = flight.id;
        }
      }

      return flightData;
    });

    const formattedActualFlightDetails = actualFlightDetails.map((flight) => {
      const flightData = {
        actual_departure: `${formatDOB(flight.actual_date_of_travel)}T${
          flight.actual_departure_time?.trim()
            ? flight.actual_departure_time
            : "00:00"
        }`,

        actual_arrival: `${formatDOB(flight.actual_arrival_date)}T${
          flight.actual_arrival_time?.trim()
            ? flight.actual_arrival_time
            : "00:00"
        }`,
        actual_airport_of_origin: flight.actual_airport_of_origin,
        actual_date_of_travel: formatDOB(flight.actual_date_of_travel),
        actual_airport_of_destination: flight.actual_airport_of_destination,
        actual_airline: flight.actual_airline,
        actual_flight_number: flight.actual_flight_number,
        provided_by_airline: flight.provided_by_airline,
        self_booked: flight.self_booked,
        ticket_ref_no: flight.ticket_ref_no,
        actual_flight_class: flight.actual_flight_class,
      };
      if (isClaimId) {
        if (flight.id !== null) {
          flightData.id = flight.id;
        }
      }

      return flightData;
    });




    // Now, you can use `formattedFlightDetails` to send to the API.

    ////console.log("Family Details", familyMembersData);

    let formObject = {
      first_name: getformData?.travelerInfo?.first_name?.trim(),
      last_name: getformData?.travelerInfo?.last_name,
      address: getformData?.travelerInfo?.address,
      passport_number: getformData?.travelerInfo?.passport_number,
      nationality: country1,
      date_of_birth: formatDOB(getformData?.travelerInfo?.date_of_birth),
      airline_res_no: getformData?.travelerInfo?.airline_res_no,
      flight_details: getformData?.claimDetails?.type_of_claim !== 'lost/damaged' ? formattedFlightDetails :[],
      actual_flight_details:
        isFlightProvided  ? getFlightDetailsFromOriginal() : [],
      // status: "pending",
      source_of_claim: "flyandclaim",
      contact_no: getformData?.travelerInfo?.contact_no,
      email_id: getformData?.travelerInfo?.email_id,
      delay: (getformData?.claimDetails?.type_of_claim !== 'other' && getformData?.claimDetails?.type_of_claim !== 'lost/damaged')?  getNewDelayDuration(true) : null,
      note: updatedNotes,
      sub_claims: familyMembersData,
      envelope_id: envolpeId,
      type_of_claim: getformData?.claimDetails?.type_of_claim,
      tickets: getformData?.travelerInfo?.tickets,
      num_of_passenger: getformData?.travelerInfo?.num_of_passenger,
      postal_code: getformData?.travelerInfo?.postal_code,
      state: getformData?.travelerInfo?.state,
      city: getformData?.travelerInfo?.city,
      user_id: user?.id,
      other_claims: additionalClaimDataPayload,
      signers: signers,
      status: "incomplete",  
      claim_amount:lostAmount,

      delay_duration_minutes:getNewDelayDuration()
    };
    // setclaimid(getformData?.travelerInfo?.contact_no);

    console.log(familyMembers);
    // if (familyMembers.length > 0) {
    //   const allHavePassport = familyMembers.every(
    //     (member) => member.passport != null
    //   );

    //   if (powerPdf && (selectPassportFile || passportImg) && allHavePassport) {
    //     formObject.status = "pending";
    //   } else {
    //     formObject.status = "incomplete";
    //   }
    // } else {
    //   if (selectPassportFile || passportImg) {
    //     formObject.status = "pending";
    //   } else {
    //     formObject.status = "incomplete";
    //   }
    // }

    // Convert the form object to JSON
    const jsonFormObject = JSON.stringify(formObject);

    // Append the JSON object to the FormData
    formData.append("data", jsonFormObject);

    // Safely access the files or use an empty array

    // Append file fields
    // formData.append(
    //   "boarding_pass",
    //   getformData?.uploadDocuments?.boarding_pass?.[0] || null // Fallback to null
    // );

    formData.append(
      "boarding_pass",
      selectBoardingFile || null // Fallback to null
    );

    formData.append(
      "passport",
      selectPassportFile || null // Fallback to null
    );
    formData.append("additional_exp", null);
    // formData.append(
    //   "passport",
    //   getformData?.uploadDocuments?.passport?.[0] || null // Fallback to null
    // );

    if (selectedAdditionalFiles) {
      for (let i = 0; i < selectedAdditionalFiles.length; i++) {
        formData.append("document", selectedAdditionalFiles[i]);
      }
    } 

   if (selectedLuggageFiles) {
      for (let i = 0; i < selectedLuggageFiles.length; i++) {
        formData.append("document", selectedLuggageFiles[i]);
      }
    }
    if (pdfBlob) {
      const pdfFile = new File([pdfBlob], "agreement.pdf", {
        type: "application/pdf",
      });
      //console.log("INSIDE PDFFILE", pdfFile);

      formData.append("agreement", pdfFile);
    } 

    if (powerPdf) {
      const pdfFile = new File([powerPdf], "power_of_attorney.pdf", {
        type: "application/pdf",
      });

      formData.append("power_of_attorney", pdfFile);
    }

    //console.log("Final Submitted Data ==================>", formData);

    setbackdropopen(true);

      saveCompensation(formData);

    // if (!isClaimId) {
    //   saveCompensation(formData);
    // }

    // if (isClaimId) {
    //   postClaimRequest(formData);
    //   // setclaimid(formObject?.contact_no);
    // }
  };

  const deleteSubclaim = (id) => {
    return axios.delete(`${base_url.api1}/tourapp/sub_claim_delete?id=${id}`);
  };

  const deleteFlightDetails = (id) => {
    return axios.delete(
      `${base_url.api1}/tourapp/flight_details_delete?id=${id}`
    );
  };

  const deleteActualFlight = (id) => {
    return axios.delete(
      `${base_url.api1}/tourapp/actual_flight_delete?id=${id}`
    );
  };

  const deleteOtherClaim = (id) => {
    return axios.delete(`${base_url.api1}/tourapp/other_claim_delete?id=${id}`);
  };

  const filterValidIds = (ids, deleteRequest) => {
    if (!Array.isArray(ids) || ids.length == 0) {
      //console.log(`Skipped no Ids provided.`);
      return [];
    }

    const validIds = ids.filter((id) => !!id);

    if (validIds.length == 0) {
      //console.log(`Skipped all Ids aer invalid.`);
      return [];
    }

    return validIds.map(deleteRequest);
  };

  const postClaimRequest = (data) => {
    axios
      .put(
        `${base_url.api1}/tourapp/compensation_request?id=${isClaimId}`,
        data,
        {
          headers: {
            Origin: "https://flyandclaim.odisoft.in",
          },
        }
      )
      .then(
        (response) => {
          ////console.log(response);
          if (response.status === 200) {
            //console.log(data);
            //console.log("Contact Number ==============> ", data?.contact_no);

            const actualFlightRemoveIds =
              isFlightProvided == "no"
                ? actualFlightDetails?.map((flight) => flight?.id)
                : actualRemoveIds;

            const deletePromises = [
              ...filterValidIds(subclaimRemoveIds, deleteSubclaim),
              ...filterValidIds(flightRemoveIds, deleteFlightDetails),
              ...filterValidIds(actualFlightRemoveIds, deleteActualFlight),
              ...filterValidIds(otherclaimRemoveIds, deleteOtherClaim),
            ];

            if (deletePromises.length == 0) {
              //console.log("deletePromises lenght zero, no delete api called.");
            } else {
              Promise.all(deletePromises)
                .then((responses) => {
                  //console.log("All delete requests completed successfully.");
                })
                .catch((error) => {
                  console.error("Delete request failed:", error.message);
                });
            }

            setbackdropopen(false);
            ////console.log("77------>", response.data.data.unique_code);
            // Swal.fire({
            //   icon: "info",
            //   title: "Save Your Claim ID",
            //   html: `Your Claim ID is: <strong>${response?.data?.data?.contact_no}</strong>. Please save it for future reference.`,
            //   confirmButtonText: "OK",
            // });
          } else {
            setbackdropopen(false);
          }
          clearLocalStorage();
          setCompletedStep(null);

          seteligible(true);
        },
        (error) => {
          Swal.fire({
            icon: "error",
            title: "Network Error",
            text: "There was a problem connecting to the server. Please try again later.",
          });

          setbackdropopen(false);
          seteligible(false);
        }
      );
  };



    const deleteDraft = async() => {
    
 
  
  
     
          axios
  
            .delete(`${base_url.api1}/users/draft_compensation_request?id=${id}`)
            .then((response) => {
     
              console.log("Delete Response", response?.data);
              
            })
            
            .catch((error) => {
     
              console.log("Error", error);
            
            }
            );
        }
  const saveCompensation = (formData) => {
    axios
      .post(`${base_url.api1}/tourapp/compensation_request`, formData, {
        headers: {
          Origin: "https://flyandclaim.odisoft.in",
        },
      })
      .then(
       async (response) => {
          ////console.log(response);
          if (response.status === 200) {


            if (id) {
              await deleteDraft();
            }
            setbackdropopen(false);
           



          } else {
            setbackdropopen(false);
          }
          clearLocalStorage();
          setCompletedStep(null);

          seteligible(true);
          setclaimid(response?.data?.data?.contact_no);
        },
        (error) => {
          Swal.fire({
            icon: "error",
            title: "Network Error",
            text: "There was a problem connecting to the server. Please try again later.",
          });

          setbackdropopen(false);
          seteligible(false);
        }
      );
  };

  const [active, setActive] = useState(1);

  const [getformData, setFormData] = useState({
    travelerInfo: {},
    claimDetails: {},
    originallyBookedFlights: {},
    actualFlightsTaken: {},
    uploadDocuments: {},
    saveOrContinueAsGuest: {},
    attorneyNotes: {},
    confirmationStatus: {},
  });


useEffect(() => {
  window.history.pushState(null, "", window.location.href);
}, []);

useEffect(() => {
  const handleBack = () => {

    if (getformData?.claimDetails?.type_of_claim === "cancelled" && active === 5) {
      setActive((current) => current - 2);
      // window.history.pushState(null, "", window.location.href);
      return;
    }

    if (getformData?.claimDetails?.type_of_claim === "lost/damaged" && active === 4) {
      setActive((current) => current - 2);
      // window.history.pushState(null, "", window.location.href);
      return;
    }

    if (active > 1) {
      setActive((current) => current - 1);
      // window.history.pushState(null, "", window.location.href);
      return;
    }

    // active === 1 → leave page
    navigate(-1);
  };

  window.addEventListener("popstate", handleBack);
  return () => window.removeEventListener("popstate", handleBack);
}, [active]);

  
 

  


  










  console.log("1537----------->", getformData?.originallyBookedFlights);

  const [stepone, setStepone] = useState(false);
  const [steptwo, setSteptwo] = useState(false);
  const [stepthree, setStepthree] = useState(false);
  const [stepfour, setStepfour] = useState(false);
  const [stepfive, setStepfive] = useState(false);
  const [stepsix, setStepsix] = useState(false);
  const [stepseven, setStepseven] = useState(false);
  const [stepeight, setStepeight] = useState(false);

  //console.log("travelerInfo--------->", getformData.travelerInfo);
  //console.log("claimDetails--------->", getformData.claimDetails);
  // //console.log(
  //   "originallyBookedFlights--------->",
  //   getformData.originallyBookedFlights
  // );
  //console.log("actualFlightsTaken--------->", getformData.actualFlightsTaken);
  //console.log("uploadDocuments--------->", getformData.uploadDocuments);
  // //console.log(
  //   "saveOrContinueAsGuest--------->",
  //   getformData.saveOrContinueAsGuest
  // );
  //console.log("attorneyNotes------------>", getformData.attorneyNotes);

  // //console.log("all data", getformData);

  const [completedStep, setCompletedStep] = useState(
    localStorage.getItem("completedStep") || 1
  );

  const setCurrentStep = (active) => {
    const step = active + 1;

    if (step > completedStep) {
      setCompletedStep(step);
      localStorage.setItem("completedStep", step);
    }
  };

  const handleFormSubmit = (data) => {
    //console.log("Form data submitted:", data);
    // Update form data state based on the current step
    if (active === 1) {
      setFormData((prev) => ({ ...prev, travelerInfo: data }));
      console.log("Form Data ======> ",data)
      setStepone(true);
      setActive((current) => current + 1);
      setCurrentStep(active);
    } else if (active === 2) {
      setFormData((prev) => ({ ...prev, claimDetails: data }));
      // setSteptwo(true);
      // setActive((current) => current + 1);
      // setCurrentStep(active);
console.log(data)

         if (data?.type_of_claim === "lost/damaged") {
        
      setStepfour(true);
      setActive((current) => current + 2);
      setCurrentStep(active);
      setIsFlightProvided("yes")
      } else {
        setSteptwo(true);
      setActive((current) => current + 1);
      setCurrentStep(active);
      }
    } else if (active === 3) {
      setFormData((prev) => ({ ...prev, originallyBookedFlights: data }));
      
      if (getformData?.claimDetails?.type_of_claim === "cancelled") {
        
setStepfive(true);
      setActive((current) => current + 2);
      setCurrentStep(active);
      setIsFlightProvided(null)
      } else {
        setStepfour(true);
      setActive((current) => current + 1);
      setCurrentStep(active);
      }
      
    } else if (active === 4) {
      setFormData((prev) => ({ ...prev, actualFlightsTaken: data }));
      setStepfour(true);
      setActive((current) => current + 1);
      setCurrentStep(active);
    } else if (active === 5) {
      // Use a callback to ensure the state is updated correctly
      setFormData((prev) => ({ ...prev, uploadDocuments: data }));
      //console.log("1575-------->", data);
      setStepfive(true);
      setActive((current) => current + 1);
      setCurrentStep(active);
    // } else if (active === 6) {
    //   setFormData((prev) => ({ ...prev, saveOrContinueAsGuest: data }));
    //   setStepsix(true);
    //   setActive((current) => current + 1);
    //   setCurrentStep(active);
    } else if (active === 6) {
      setFormData((prev) => ({ ...prev, attorneyNotes: data }));
      setStepsix(true);
      onSubmit(data.note);
      if (pdfBlob) {
        setActive((current) => current + 1);
        setCurrentStep(active);
      }
    }
  };

  const handleNext = () => {
    if (active === 1) {
      const form = document.getElementById("travel-information-form");
      if (form) form.requestSubmit();
    } else if (active === 2) {
      const form = document.getElementById("claim-details-form");
      if (form) form.requestSubmit();
    } else if (active === 3) {
      const form = document.getElementById("original-flight-form");
      if (form) form.requestSubmit();
    } else if (active === 4) {
      const form = document.getElementById("actual-flight-form");
      if (form) form.requestSubmit();
    } else if (active === 5) {
      const form = document.getElementById("upload-document-form");
      if (form) form.requestSubmit();
    // } else if (active === 6) {
    //   const form = document.getElementById("continue-guest-form");
    //   if (form) form.requestSubmit();
    } else if (active === 6) {
      const form = document.getElementById("attorney-notes-form");
      if (form) form.requestSubmit();
    } else {
      setActive((current) => current + 1);
    }
  };

  // Determine the button text based on the current step
  const getButtonText = () => {
    if (active === 6) {
      return "Submit"; // Button text for the 5th step
    } else {
      return "Next"; // Default button text for other steps
    }
  };

  const validateValue = (value) => {
    if (value === "" || value === null || value === undefined) {
      return true;
    }
    return false;
  };

const handleUploadFile = async ( file) => {

 
    try {
    const formData = new FormData();

    // const requestData = {
    //   user_id: user?.id,
    //   };
      
       const requestData = {
      user_id: null,
    };

    const jsonFormObject = JSON.stringify(requestData);
    formData.append("data", jsonFormObject);

    formData.append('image', file || null);

    const response = await axios.post(
      `${base_url.api1}/users/draft_file`,
      formData,
      {
        headers: {
          Origin: "https://flyandclaim.odisoft.in",
          "Content-Type": "multipart/form-data",
        },
      }
    );

    console.log(response?.data?.data[0].file);
    return response?.data?.data[0].file;
  } catch (error) {
      console.log(error.message);
      setbackdropopen(false);
      
  }
  
  

  
  };
  
    const uploadIfExists = async (file) => {
      if (file ) {
        return await handleUploadFile( file);
      }
      return null;
    };


  // //console.log("userrrrrrrrrrrrr", user.id);
//   const handleSaveClick = async () => {
   
//     if (!user?.id) {
//       setIsRegisteredModalOpen(true);
//       setOpenLogin(true)
//       return;
//     }

  

//     const updatedNotes = addCustomerNote(
//       getformData?.attorneyNotes?.note,
//       previousNote
//     );

   

//      const familyMembersData =await Promise.all( familyMembers.map(async(member, index) => {
//       const memberData = {
//         first_name: validateValue(member?.first_name?.trim()) ? null : member?.first_name?.trim(),
//         last_name: validateValue(member.last_name) ? null : member?.last_name,
//         date_of_birth: validateValue(formatDOB(member.date_of_birth)) ? null : formatDOB(member.date_of_birth) ,
//         passport_number: validateValue(member.passport_number) ? null : member.passport_number,
//         tickets: validateValue(member.tickets) ? null : member.tickets,
//         country: validateValue(member.country) ? null : member.country,
//         airline_res_no: validateValue(member.airline_res_no) ? null : member.airline_res_no,
//       };

     
       
//         const passportFile  = await uploadIfExists(member.passport)
//         if (passportFile) memberData.passport = passportFile;
      
     
//          const additionalDocFile  = await uploadIfExists(member.additional_doc)
//         if (additionalDocFile) memberData.additional_doc = additionalDocFile;
       
      
      
//            const boardingPassFile  = await uploadIfExists(member.boarding_pass)
//        if (boardingPassFile) memberData.boarding_pass = boardingPassFile;
      
       
      
//       if (isClaimId) {
//         if (member.id !== null) {
//           memberData.id = member.id;
//         }
//       }

//       return memberData;
//     }));

//     const formattedFlightDetails = flightDetails.map((flight,index) =>
//     {


      
//       const flightData = {
//         airline:  validateValue(flight.airline) ? null:flight.airline,
//         airline_code:validateValue(flight?.hub_code)? null : flight?.hub_code,
//         flight_number: validateValue(flight.flight_number) ? null :flight.flight_number,
//         airport_of_origin: validateValue(flight.airport_of_origin) ? null : flight.airport_of_origin,
//         airport_of_destination: validateValue(flight.airport_of_destination) ? null : flight.airport_of_destination,
//         scheduled_arrival: validateValue(flight.original_arrival_date) ? null :  `${formatDOB(flight.original_arrival_date)}T${
//           flight.original_arrival_time &&
//           flight.original_arrival_time.trim() !== ""
//             ? flight.original_arrival_time
//             : "00:00"
//         }`,
//         scheduled_departure: validateValue(flight.date_of_travel) ? null : `${formatDOB(flight.date_of_travel)}T${
//           flight.original_departure_time &&
//           flight.original_departure_time.trim() !== ""
//             ? flight.original_departure_time
//             : "00:00"
//         }`,
//         date_of_travel: validateValue(flight.date_of_travel) ? null : formatDOB(flight.date_of_travel),
//         disruption: flight.delayed
//           ? "delayed"
//           : flight.cancelled
//           ? "cancelled"
//           : flight.missed
//           ? "missed"
//           : flight.denied
//           ? "denied"
//           : flight.downgraded
//           ? "downgraded"
//           : flight.disruption,
//         delay_duration: flight.delay_duration === "none" ? null:flight.delay_duration,
//         delay_cal:flight.delay_duration_minutes || 0,
//         flight_cancel: validateValue(flight.flight_cancel),
//         missed_connection: flight.missed_connection ,
//         // claim_details: flight.claim_details,
//         additional_details: flight.additional_details,
//         ticket_ref_no: flight.ticket_ref_no,
//         delayed: flight.disruption === "delayed",
//         cancelled: flight.disruption === "cancelled",
//         missed: flight.disruption === "missed",
//         denied: flight.disruption === "denied",
//         downgraded: flight.disruption === "downgraded",
//         cancellation_info_before: flight.cancellation_info_before,
//         cancellation_info_at_airport: flight.cancellation_info_at_airport,
//         missed_due_to_error: flight.missed_due_to_error,
//         missed_due_to_personal: flight.missed_due_to_personal,
//         flight_class: flight.flight_class,
//         sequence:index+1
//       };

//       if (isClaimId) {
//         if (flight.id !== null) {
//           flightData.id = flight.id;
//         }
//       }

//       return flightData;
//     });

//     const formattedActualFlightDetails = actualFlightDetails.map((flight) => ({
//       actual_departure:
//         `${formatDOB(flight.actual_date_of_travel)}T${
//           flight.actual_departure_time || "00:00"
//         }` === ""
//           ? null
//           : `${formatDOB(flight.actual_date_of_travel)}T${
//               flight.actual_departure_time || "00:00"
//             }`,

//       actual_arrival:
//         `${formatDOB(flight.actual_arrival_date)}T${
//           flight.actual_arrival_time || "00:00"
//         }` === ""
//           ? null
//           : `${formatDOB(flight.actual_arrival_date)}T${
//               flight.actual_arrival_time || "00:00"
//             }`,

//       actual_airport_of_origin: validateValue(flight.actual_airport_of_origin)
//         ? null
//         : flight.actual_airport_of_origin,
//       actual_date_of_travel: validateValue(flight.actual_date_of_travel)
//         ? null
//         : formatDOB(flight.actual_date_of_travel),
//       actual_airport_of_destination: validateValue(
//         flight.actual_airport_of_destination
//       )
//         ? null
//         : flight.actual_airport_of_destination,
//       actual_airline: validateValue(flight.actual_airline)
//         ? null
//         : flight.actual_airline,
//       actual_flight_number: validateValue(flight.actual_flight_number)
//         ? null
//         : flight.actual_flight_number,
//       ticket_ref_no: validateValue(flight.ticket_ref_no)
//         ? null
//         : flight.ticket_ref_no,
//       provided_by_airline: flight.provided_by_airline,
//       self_booked: flight.self_booked,
//     }));

//     let saveFormObject = {
//       first_name: validateValue(getformData?.travelerInfo?.first_name)
//         ? null
//         : getformData?.travelerInfo?.first_name,
//       last_name: validateValue(getformData?.travelerInfo?.last_name)
//         ? null
//         : getformData?.travelerInfo?.last_name,
//       address: validateValue(getformData?.travelerInfo?.address)
//         ? null
//         : getformData?.travelerInfo?.address,
//       passport_number: validateValue(getformData?.travelerInfo?.passport_number)
//         ? null
//         : getformData?.travelerInfo?.passport_number,
//       nationality: validateValue(country1) ? null : country1,
//       date_of_birth: validateValue(getformData?.travelerInfo?.date_of_birth)
//         ? null
//         : formatDOB(getformData?.travelerInfo?.date_of_birth),
//       airline_res_no: validateValue(getformData?.travelerInfo?.airline_res_no)
//         ? null
//         : getformData?.travelerInfo?.airline_res_no,
//       flight_details:
//         formattedFlightDetails.length === 0 ? [] : formattedFlightDetails,

//       actual_flight_details:
//         isFlightProvided  ?  getFlightDetailsFromOriginal() : [],
//       // status: "incomplete",
//       source_of_claim: "flyandclaim",
//       contact_no: validateValue(getformData?.travelerInfo?.contact_no)
//         ? null
//         : getformData?.travelerInfo?.contact_no,
//       email_id: validateValue(getformData?.travelerInfo?.email_id)
//         ? null
//         : getformData?.travelerInfo?.email_id,
//       // delay: delay === "" ? null : delay !== "HH:MM" ? delay : null,
//       note: !updatedNotes || updatedNotes.length === 0 ? null : updatedNotes,
//       tickets: validateValue(getformData?.travelerInfo?.tickets)
//         ? null
//         : getformData?.travelerInfo?.tickets,
//       sub_claims: familyMembersData.length === 0 ? [] : familyMembersData,
//       // other_claims:
//       //   additionalClaimDataPayload.length === 0
//       //     ? null
//       //     : additionalClaimDataPayload,
//       other_claims:null,
//       envelope_id: envolpeId,
//       type_of_claim: validateValue(getformData?.claimDetails?.type_of_claim)
//         ? null
//         : getformData?.claimDetails?.type_of_claim,
//       num_of_passenger: validateValue(
//         getformData?.travelerInfo?.num_of_passenger
//       )
//         ? null
//         : getformData?.travelerInfo?.num_of_passenger,
//       postal_code: validateValue(getformData?.travelerInfo?.postal_code)
//         ? null
//         : getformData?.travelerInfo?.postal_code,
//       state: validateValue(getformData?.travelerInfo?.state)
//         ? null
//         : getformData?.travelerInfo?.state,
//       city: validateValue(getformData?.travelerInfo?.city)
//         ? null
//         : getformData?.travelerInfo?.city,
//       user_id: user?.id,
//       claim_amount:validateValue(lostAmount)
//         ? null
//         : lostAmount,
//        delay_duration_minutes:getNewDelayDuration()
//     };

//     console.log(saveFormObject);

//     const boardingPassMain = await uploadIfExists(selectBoardingFile);
//     if (boardingPassMain) {
//       saveFormObject.boarding_pass = boardingPassMain
//     }
//  const passportMain = await uploadIfExists(selectPassportFile);

//      if (passportMain) {
//       saveFormObject.passport = passportMain
//     }

//     // Convert the form object to JSON
//     const jsonFormObject = JSON.stringify(saveFormObject);

    


//     const data = {
//       user_id: user?.id,
//       request_data: jsonFormObject,
//       status:"draft"
//     }

//     if (!id) {
//       setbackdropopen(true);
//       try {
//         const response = await axios.post(
//           `${base_url.api1}/users/draft_compensation_request`,
//           data,
//           {
//             headers: {
//               Origin: "https://flyandclaim.odisoft.in",
//             },
//           }
//         );

//         //console.log("saved form data by save click", response.data);
//         clearLocalStorage();
//         open2();
//         closeOriginal4();
//         setbackdropopen(false);
//       } catch (error) {
//         //console.log("error saving form data by save click", error);

//         setbackdropopen(false);
//       }
//     } else {
//         setbackdropopen(true);
//       try {
//         const response = await axios.put(
//           `${base_url.api1}/users/draft_compensation_request?id=${id}`,
//           data,
//           {
//             headers: {
//               Origin: "https://flyandclaim.odisoft.in",
//             },
//           }
//         );

//         //console.log("saved form data by save click", response.data);
//         clearLocalStorage();
//         open2();
//         closeOriginal4();
//         setbackdropopen(false);
//       } catch (error) {
//         //console.log("error saving form data by save click", error);

//         setbackdropopen(false);
//       }
//     }
//   };

  
  
  const handleSaveClick = async () => {
     setTemporaryOpened(false);
   
    // if (!user?.id) {
    //   setIsRegisteredModalOpen(true);
    //   setOpenLogin(true)
    //   return; 
    // }

      setbackdropopen(true);
    

    // const updatedNotes = addCustomerNote(
    //   getformData?.attorneyNotes?.note,
    //   previousNote
    // );

   

     const familyMembersData =await Promise.all( familyMembers.map(async(member, index) => {
      const memberData = {
        first_name: validateValue(member?.first_name?.trim()) ? null : member?.first_name?.trim(),
        last_name: validateValue(member.last_name) ? null : member?.last_name,
        date_of_birth: validateValue(formatDOB(member.date_of_birth)) ? null : formatDOB(member.date_of_birth) ,
        passport_number: validateValue(member.passport_number) ? null : member.passport_number,
        tickets: validateValue(member.tickets) ? null : member.tickets,
        country: validateValue(member.country) ? null : member.country,
        airline_res_no: validateValue(member.airline_res_no) ? null : member.airline_res_no,
      };

     
       
        const passportFile  = await uploadIfExists(member.passport)
        if (passportFile) memberData.passport = passportFile;
      
     
         const additionalDocFile  = await uploadIfExists(member.additional_doc)
        if (additionalDocFile) memberData.additional_doc = additionalDocFile;
       
      
      
           const boardingPassFile  = await uploadIfExists(member.boarding_pass)
       if (boardingPassFile) memberData.boarding_pass = boardingPassFile;
      
       
      
      if (isClaimId) {
        if (member.id !== null) {
          memberData.id = member.id;
        }
      }

      return memberData;
    }));

    const formattedFlightDetails = flightDetails.map((flight,index) =>
    {


      
      const flightData = {
        airline:  validateValue(flight.airline) ? null:flight.airline,
        airline_code:validateValue(flight?.hub_code)? null : flight?.hub_code,
        flight_number: validateValue(flight.flight_number) ? null :flight.flight_number,
        airport_of_origin: validateValue(flight.airport_of_origin) ? null : flight.airport_of_origin,
        airport_of_destination: validateValue(flight.airport_of_destination) ? null : flight.airport_of_destination,
        scheduled_arrival: validateValue(flight.original_arrival_date) ? null :  `${formatDOB(flight.original_arrival_date)}T${
          flight.original_arrival_time &&
          flight.original_arrival_time.trim() !== ""
            ? flight.original_arrival_time
            : "00:00"
        }`,
        scheduled_departure: validateValue(flight.date_of_travel) ? null : `${formatDOB(flight.date_of_travel)}T${
          flight.original_departure_time &&
          flight.original_departure_time.trim() !== ""
            ? flight.original_departure_time
            : "00:00"
        }`,
        date_of_travel: validateValue(flight.date_of_travel) ? null : formatDOB(flight.date_of_travel),
        disruption: flight.delayed
          ? "delayed"
          : flight.cancelled
          ? "cancelled"
          : flight.missed
          ? "missed"
          : flight.denied
          ? "denied"
          : flight.downgraded
          ? "downgraded"
          : flight.disruption,
        delay_duration: flight.delay_duration === "none" ? null:flight.delay_duration,
        delay_cal:flight.delay_duration_minutes || 0,
        flight_cancel: validateValue(flight.flight_cancel),
        missed_connection: flight.missed_connection ,
        // claim_details: flight.claim_details,
        additional_details: flight.additional_details,
        ticket_ref_no: flight.ticket_ref_no,
        delayed: flight.disruption === "delayed",
        cancelled: flight.disruption === "cancelled",
        missed: flight.disruption === "missed",
        denied: flight.disruption === "denied",
        downgraded: flight.disruption === "downgraded",
        cancellation_info_before: flight.cancellation_info_before,
        cancellation_info_at_airport: flight.cancellation_info_at_airport,
        missed_due_to_error: flight.missed_due_to_error,
        missed_due_to_personal: flight.missed_due_to_personal,
        flight_class: flight.flight_class,
        sequence:index+1
      };

      if (isClaimId) {
        if (flight.id !== null) {
          flightData.id = flight.id;
        }
      }

      return flightData;
    });

    const formattedActualFlightDetails = actualFlightDetails.map((flight) => ({
      actual_departure:
        `${formatDOB(flight.actual_date_of_travel)}T${
          flight.actual_departure_time || "00:00"
        }` === ""
          ? null
          : `${formatDOB(flight.actual_date_of_travel)}T${
              flight.actual_departure_time || "00:00"
            }`,

      actual_arrival:
        `${formatDOB(flight.actual_arrival_date)}T${
          flight.actual_arrival_time || "00:00"
        }` === ""
          ? null
          : `${formatDOB(flight.actual_arrival_date)}T${
              flight.actual_arrival_time || "00:00"
            }`,

      actual_airport_of_origin: validateValue(flight.actual_airport_of_origin)
        ? null
        : flight.actual_airport_of_origin,
      actual_date_of_travel: validateValue(flight.actual_date_of_travel)
        ? null
        : formatDOB(flight.actual_date_of_travel),
      actual_airport_of_destination: validateValue(
        flight.actual_airport_of_destination
      )
        ? null
        : flight.actual_airport_of_destination,
      actual_airline: validateValue(flight.actual_airline)
        ? null
        : flight.actual_airline,
      actual_flight_number: validateValue(flight.actual_flight_number)
        ? null
        : flight.actual_flight_number,
      ticket_ref_no: validateValue(flight.ticket_ref_no)
        ? null
        : flight.ticket_ref_no,
      provided_by_airline: flight.provided_by_airline,
      self_booked: flight.self_booked,
    }));

    let saveFormObject = {
      first_name: validateValue(getformData?.travelerInfo?.first_name)
        ? null
        : getformData?.travelerInfo?.first_name,
      last_name: validateValue(getformData?.travelerInfo?.last_name)
        ? null
        : getformData?.travelerInfo?.last_name,
      address: validateValue(getformData?.travelerInfo?.address)
        ? null
        : getformData?.travelerInfo?.address,
      passport_number: validateValue(getformData?.travelerInfo?.passport_number)
        ? null
        : getformData?.travelerInfo?.passport_number,
      nationality: validateValue(country1) ? null : country1,
      date_of_birth: validateValue(getformData?.travelerInfo?.date_of_birth)
        ? null
        : formatDOB(getformData?.travelerInfo?.date_of_birth),
      airline_res_no: validateValue(getformData?.travelerInfo?.airline_res_no)
        ? null
        : getformData?.travelerInfo?.airline_res_no,
      flight_details:
       flightDetails,

      actual_flight_details:
        actualFlightDetails,
      // status: "incomplete",
     
      contact_no: validateValue(getformData?.travelerInfo?.contact_no)
        ? null
        : getformData?.travelerInfo?.contact_no,
      email_id: validateValue(getformData?.travelerInfo?.email_id)
        ? null
        : getformData?.travelerInfo?.email_id,
      // delay: delay === "" ? null : delay !== "HH:MM" ? delay : null,
      note: validateValue(draftNote) ? null : draftNote,
      tickets: validateValue(getformData?.travelerInfo?.tickets)
        ? null
        : getformData?.travelerInfo?.tickets,
      sub_claims: familyMembersData.length === 0 ? [] : familyMembersData,
      // other_claims:
      //   additionalClaimDataPayload.length === 0
      //     ? null
      //     : additionalClaimDataPayload,
      other_claims:null,
      envelope_id: envolpeId,
      type_of_claim: validateValue(getformData?.claimDetails?.type_of_claim)
        ? null
        : getformData?.claimDetails?.type_of_claim,
      num_of_passenger: validateValue(
        getformData?.travelerInfo?.num_of_passenger
      )
        ? null
        : getformData?.travelerInfo?.num_of_passenger,
      postal_code: validateValue(getformData?.travelerInfo?.postal_code)
        ? null
        : getformData?.travelerInfo?.postal_code,
      state: validateValue(getformData?.travelerInfo?.state)
        ? null
        : getformData?.travelerInfo?.state,
      city: validateValue(getformData?.travelerInfo?.city)
        ? null
        : getformData?.travelerInfo?.city,
      user_id: user?.id,
      claim_amount:validateValue(lostAmount)
        ? null
        : lostAmount,
      delay_duration_minutes: getNewDelayDuration(),
      flightProvider: isFlightProvided,
       activeStep:active
    };

    console.log(saveFormObject);

    const boardingPassMain = await uploadIfExists(selectBoardingFile);
    if (boardingPassMain) {
      saveFormObject.boarding_pass = boardingPassMain
    }
 const passportMain = await uploadIfExists(selectPassportFile);

     if (passportMain) {
      saveFormObject.passport = passportMain
    }

    // Convert the form object to JSON
    const jsonFormObject = JSON.stringify(saveFormObject);

    


    const data = {
      // user_id: user?.id,
      request_data: saveFormObject,
      status:"draft"
    }

    if (!id) {
      try {
        const response = await axios.post(
          `${base_url.api1}/users/draft_compensation_request`,
          data,
          {
            headers: {
              Origin: "https://flyandclaim.odisoft.in",
            },
          }
        );

        //console.log("saved form data by save click", response.data);
        clearLocalStorage();
        open2();
        closeOriginal4();
        setbackdropopen(false);
      } catch (error) {
        //console.log("error saving form data by save click", error);

        setbackdropopen(false);
      }
    } else {
        // setbackdropopen(true);
      try {
        const response = await axios.put(
          `${base_url.api1}/users/draft_compensation_request?id=${id}`,
          data,
          {
            headers: {
              Origin: "https://flyandclaim.odisoft.in",
            },
          }
        );

        //console.log("saved form data by save click", response.data);
        clearLocalStorage();
        open2();
        closeOriginal4();
        setbackdropopen(false);
      } catch (error) {
        //console.log("error saving form data by save click", error);

        setbackdropopen(false);
      }
    } 
  };
  
  
  const location = useLocation();
  const { claim_id: id } = useParams();

  
  const [userChecked, setUserChecked] = useState(false);
  const [isClaimId, setIsClaimId] = useState(null);
  const [draftNote, setDraftNote] = useState(null);

  const [claimData, setClaimData] = useState({});
  const [previousNote, setPreviousNote] = useState("");
  const [boardingImg, setBoardingImg] = useState();
  const [passportImg, setPassportImg] = useState();
  const [agreement, setAgreement] = useState();
  const [additionalImg, setAdditionalImg] = useState([]);
  const [notes, setNote] = useState();
  const [otherDoc, setOtherDoc] = useState([]);

  const formatToMMDDYYYY = (dateString) => {
    if (!dateString) return "";
   return moment(dateString).format("MM-DD-YYYY");
    // const date = new Date(dateString);
    // const month = String(date.getMonth() + 1).padStart(2, "0");
    // const day = String(date.getDate()).padStart(2, "0");
    // const year = date.getFullYear();
    // return `${month}-${day}-${year}`;
  };

  async function urlToFile(url, fileBaseName) {
  if (!url) return null;            // No URL -> no file
    url = attachmenturl+url
  try {
    const response = await fetch(url);
    if (!response.ok) return null;  // Invalid URL -> skip

    const blob = await response.blob();

    const ext = blob.type.split("/")[1] || "bin";
    const fileName = `${fileBaseName}.${ext}`;

    return new File([blob], fileName, { type: blob.type });
  } catch (e) {
    console.warn("Failed to convert URL to file:", url, e);
    return null;
  }
}

  const fetchData = async () => {
    setbackdropopen(true);

    try {
      const response = await axios.get(
        `${base_url.api1}/users/draft_compensation_request?id=${id}`
      );
      let claimDetails = response.data.compensation_request?.request_data;
      console.log("Claim Details ========================-->", claimDetails);
      setClaimData({
        num_of_passenger: claimDetails.num_of_passenger,
        state: claimDetails.state,
        city: claimDetails.city,
        postal_code: claimDetails.postal_code,
        first_name: claimDetails.first_name,
        last_name: claimDetails.last_name,
        address: claimDetails.address,
        passport_number: claimDetails.passport_number,
        nationality: claimDetails.nationality,
        date_of_birth: formatToMMDDYYYY(claimDetails.date_of_birth),
        // airline: claimDetails.airline,
        // flight_number: claimDetails.flight_number,
        // airpotr_of_origin: claimDetails.airpotr_of_origin,
        // airpotr_of_destination: claimDetails.airpotr_of_destination,
        unique_code: claimDetails.unique_code,
        contact_no: claimDetails.contact_no,
        note: claimDetails.note,
        email_id: claimDetails.email_id,
        status: claimDetails.status,
        receive_any_compensation: claimDetails.receive_any_compensation,
        status: claimDetails.status,
        unique_code: claimDetails.unique_code,
        type_of_claim: claimDetails.type_of_claim, // date_of_travel: claimDetails.date_of_travel,
        tickets: claimDetails.tickets,
        claim_id: claimDetails.contact_no,
        source_of_claim: claimDetails.source_of_claim,
        airline_res_no: claimDetails.airline_res_no,
      });


       setFormData((prev) => ({ ...prev, travelerInfo: {
          contact_no: claimDetails.contact_no || "",
          num_of_passenger: claimDetails.num_of_passenger || "",
          first_name: claimDetails.first_name || "",
          last_name: claimDetails.last_name || "",
          date_of_birth: formatToMMDDYYYY(claimDetails.date_of_birth) || "",
          email_id: claimDetails.email_id || "",
          passport_number: claimDetails.passport_number || "",
          state: claimDetails.state || "",
          city: claimDetails.city || "",
          postal_code: claimDetails.postal_code || "",
          address: claimDetails.address || "",
          tickets: claimDetails.tickets || "",
          airline_res_no: claimDetails.airline_res_no || "",
       }
       }));
      setFormData((prev) => ({ ...prev, claimDetails: claimDetails.type_of_claim ? {
        type_of_claim: claimDetails.type_of_claim,
      } : {} }));

      setclaimid(claimDetails.contact_no);
      setcountry(claimDetails.nationality);
      setLostAmount(claimDetails.claim_amount || null);
      setCountryValid(false);
      setBoardingImg(claimDetails.boarding_pass);
      setAdditionalImg(claimDetails.other_doc);
      setPassportImg(claimDetails.passport);
      setAgreement(claimDetails.agreement);
      // setPreviousNote(claimDetails.note);
      setDraftNote(claimDetails.note);
      setOtherDoc(claimDetails.other_doc);
      setIsFlightProvided(claimDetails.flightProvider);
      setActive(claimDetails?.activeStep || 1);
      
      
      if (claimDetails.boarding_pass) {
         const mainBoardingPass = await urlToFile(
        claimDetails?.boarding_pass || null,
       claimDetails?.boarding_pass?.split("/").pop().split(".")[0] || `boarding_pass`
        );
        
        setSelectBoardingFile(mainBoardingPass)
      }

      if (claimDetails.passport) {
         const mainPassport = await urlToFile(
        claimDetails?.passport || null,
              claimDetails?.passport?.split("/").pop().split(".")[0] || `passport`

        );
        
        setSelectPassportFile(mainPassport)
      }

      // if (claimDetails.other_claims.length > 0) {
      //   setAdditionalClaimData(claimDetails.other_claims);

      //   const defaultValidation = {
      //     claim_type: false,
      //     amount: false,
      //     claim_explanation: false,
      //     other_claim_doc: false,
      //   };

      //   const validationArray = claimDetails.other_claims.map(() => ({
      //     ...defaultValidation,
      //   }));

      //   setAdditionalClaimValidation(validationArray);
      // }

      if (claimDetails?.sub_claims && claimDetails?.sub_claims.length > 0) {
         const transformed = await Promise.all(
    claimDetails.sub_claims.map(async (claim, index) => {

      // Convert passport URL → File (may be null)
      const passportFile = await urlToFile(
        claim?.passport || null,
               claim?.passport?.split("/").pop().split(".")[0] || `passport`

      );

      // Convert boarding pass URL → File (may be null)
      const boardingPassFile = await urlToFile(
        claim?.boarding_pass || null,
                       claim?.boarding_pass?.split("/").pop().split(".")[0] || `boarding_pass`

      );


      return {
        ...claim,
        date_of_birth: formatToMMDDYYYY(claim.date_of_birth),

        // Passport fields safely added
        passport: passportFile,
        passport_name: passportFile ? `passport_${index + 1}` : null,
        passport_file_name: passportFile?.name || null,

        // Boarding pass fields safely added
        boarding_pass: boardingPassFile,
        boardingpass_name: boardingPassFile ? `boarding_pass_${index + 1}` : null,
        boarding_pass_file_name: boardingPassFile?.name || null,
      };
    })
  );

  setFamilyMembers(transformed);
      }
      setPowerPdf(claimDetails.power_of_attorney);
      if (
        claimDetails?.flight_details &&
        claimDetails?.flight_details.length > 0
      ) {
       
        setFlightDetails(claimDetails.flight_details);
      }
      if (claimDetails?.actual_flight_details) {
        if (claimDetails?.actual_flight_details.length > 0) {
         
        

          setActualFlightDetails(claimDetails?.actual_flight_details);
        }
      }

      const dataToSave = {
        formValues: {
          email_id: claimDetails?.email_id,
          contact_no: claimDetails?.contact_no,
          first_name: claimDetails?.first_name,
          last_name: claimDetails?.last_name,
          address: claimDetails?.address,
          city: claimDetails?.city,
          postal_code: claimDetails?.postal_code,
        },
        country1: claimDetails?.nationality,
        familyMembers,
      };
      localStorage.setItem(
        "travelerInformationData",
        JSON.stringify(dataToSave)
      );

      setDelay(claimDetails?.delay);

      setbackdropopen(false);
    } catch (error) {
      // //console.log(error)
      if (error?.response?.data?.status_code == 400) {
        navigate("/claimstatus");
      }
      setbackdropopen(false);
    }
  };

  console.log(getformData);

  useEffect(() => {
    if (id) {
      setUserChecked(true);
      // setIsClaimId(id);
      fetchData();
    }
  }, [id]);

  const [opened, { open: open2, close: closeOriginal2 }] = useDisclosure(false);
  const [opened2, { open: open3, close: closeOriginal3 }] =
    useDisclosure(false);
  const [opened3, { open: open4, close: closeOriginal4 }] =
    useDisclosure(false);

  // Create wrapped close functions that navigate after closing
  const close2 = () => {
    closeOriginal2();
    navigate("/drafts");
  };

  const close3 = () => {
    closeOriginal3();
    navigate("/dashboard");
  };

  const handleOpen4 = () => {
    stepseven ? close4() : open4();
  };

  const close4 = () => {
    closeOriginal4();

    setTimeout(() => {
      
      stepseven && navigate("/dashboard");
    },200)
  };

  const [
    additionalClaimModalOpened,
    { open: openAdditionalClaim, close: closeAdditionalClaim },
  ] = useDisclosure(false);

  const handleFormChange = (field, value, index) => {
    const updatedAdditionlaClaims = [...additionalClaimData];
    updatedAdditionlaClaims[index][field] = value;
    setAdditionalClaimData(updatedAdditionlaClaims);

    const updatedValidation = [...additionalClaimValidation];
    updatedValidation[index][field] = false;
    setAdditionalClaimValidation(updatedValidation);
  };

  const handleFileChange = (event, index) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const updatedAdditionlaClaims = [...additionalClaimData];
      updatedAdditionlaClaims[index]["other_claim_doc"] = file;
      updatedAdditionlaClaims[index][
        "other_claim_doc_name"
      ] = `other_claim_doc_${index + 1}`;
      updatedAdditionlaClaims[index]["show_claim_doc_name"] = file.name;

      setAdditionalClaimData(updatedAdditionlaClaims);

      const updatedValidation = [...additionalClaimValidation];
      updatedValidation[index]["other_claim_doc"] = false;
      setAdditionalClaimValidation(updatedValidation);
    }
  };

  const handleAdditionalClaimType = () => {
    if (additionalClaimData?.length <= 0) {
      return;
    }

    let errorFlag = false;

    additionalClaimData.forEach((claimData, index) => {
      const updatedValidation = [...additionalClaimValidation];

      if (claimData["claim_type"] == "") {
        updatedValidation[index]["claim_type"] = true;
        errorFlag = true;
      }

      if (claimData["amount"] == "") {
        updatedValidation[index]["amount"] = true;
        errorFlag = true;
      }

      if (claimData["claim_explanation"] == "") {
        updatedValidation[index]["claim_explanation"] = true;
        errorFlag = true;
      }

      if (claimData["other_claim_doc"] == null) {
        updatedValidation[index]["other_claim_doc"] = true;
        errorFlag = true;
      }

      setAdditionalClaimValidation(updatedValidation);
    });
    if (errorFlag) return;

    closeAdditionalClaim();
  };

  const getAddionalClaimFileName = (index) => {
    let fileName;

    fileName = additionalClaimData[index]["show_claim_doc_name"]
      ? additionalClaimData[index]["show_claim_doc_name"]
      : additionalClaimData[index]["other_claim_doc"]
      ? additionalClaimData[index]["other_claim_doc"].split("/").pop()
      : "Upload File";

    return fileName;
  };

  const isMobile = useMediaQuery("(max-width: 768px)");

  const [isRegisterModalOpen, setIsRegisteredModalOpen] = useState(false);
  const [openLogin, setOpenLogin] = useState(false);
  const [openRegister, setOpenRegister] = useState(false);
  const [openForgotPassworod, setOpenForgotPassword] = useState(false);
  const [openChangePassworod, setOpenChangePassword] = useState(false);

  const authFlow = (type) => {
    if (type === 'login') {
      setOpenRegister(false);
      setOpenChangePassword(false)

      setOpenForgotPassword(false)
      setOpenLogin(true);
    } else if (type === "register") {
      setOpenForgotPassword(false)
      setOpenLogin(false);
      setOpenChangePassword(false)

      setOpenRegister(true);
    } else if (type === 'password') {
      setOpenLogin(false);
      setOpenRegister(false);
      setOpenChangePassword(false)

      setOpenForgotPassword(true)
    } else if (type === 'change') {
       setOpenLogin(false);
      setOpenRegister(false);
      setOpenForgotPassword(false)
      setOpenChangePassword(true)
    } else if (type === 'none') {
      setIsRegisteredModalOpen(false)
       setOpenLogin(false);
      setOpenRegister(false);
      setOpenForgotPassword(false)
      setOpenChangePassword(false)
      
    }
  }

  const [temporaryOpened, setTemporaryOpened] = useState(false);

  
    function getFlightStatus(code) {
  switch (code) {
    case "A":
      return "Active (in flight)";
    case "C":
      return "Canceled";
    case "D":
      return "Diverted";
    case "DN":
      return "Data Needed / Not Available";
    case "L":
      return "Landed";
    case "NO":
      return "Not Operational";
    case "R":
      return "Redirected";
    case "S":
      return "Scheduled";
    case "U":
      return "Unknown";
    default:
      return code;
  }
  }
  
   const fmt = (dt) => {
  if (!dt) return "N/A"; // null, undefined, empty, 0

  const date = new Date(dt);
  if (isNaN(date.getTime())) return "N/A"; // invalid date

  return date.toLocaleString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
  };
  
  const [selectedFlightIndex, setSelectedFlightIndex] = useState(null);
  console.log(selectedFlightIndex)
  const handleSelectFlight = (index) => {
    setSelectedFlightIndex(index);
  setMultiFlightData(prev => 
    prev.map((f, i) => ({
      ...f,
      selected: i === index  // only one true
    }))
  );
  };
  


  const handleSaveFlightDetails = () => {
    // const selectedFlight = multiFlightData.find(f => f.selected);
    const flightList = filteredFlightData[selectedFlightIndex];
    console.log(flightList)
   if (flightList) {
        const updatedFlightDetails =
          triggerFrom === "actual"
            ? [...actualFlightDetails]
            : [...flightDetails]; // Assuming flightDetails is a state variable.

        if (triggerFrom === "actual") {
          // const actualArrivalTime = flightList.arrival.arrivalActual || "";
          // const originalArrivalTime =
          //   updatedFlightDetails[triggerIndex].original_arrival_time || "";

          // let delay = "";
          // if (actualArrivalTime && originalArrivalTime) {
          //   delay = calculateDelay(actualArrivalTime, originalArrivalTime);
          //   setDelay(delay);
          // }

          updatedFlightDetails[triggerIndex] = {
            ...updatedFlightDetails[triggerIndex],
            actual_departure_time:
              flightList.departure.departureActual &&
              flightList.departure.departureActual !== null &&
              flightList.departure.departureActual !== undefined &&
              flightList.departure.departureActual !== "" &&
              flightList.departure.departureActual !== "+00:00"
                ? dateFormat(flightList.departure.departureActual,flightList.departure.timeZone)
                   
                    .time
                : "",
            actual_departure_date:
              flightList.departure.departureActual &&
              flightList.departure.departureActual !== null &&
              flightList.departure.departureActual !== undefined &&
              flightList.departure.departureActual !== "" &&
              flightList.departure.departureActual !== "+00:00"
                ?dateFormat(flightList.departure.departureActual,flightList.departure.timeZone)
                   
                    .date
                : "",
            actual_arrival_time:
              flightList.arrival.arrivalActual &&
              flightList.arrival.arrivalActual !== null &&
              flightList.arrival.arrivalActual !== undefined &&
              flightList.arrival.arrivalActual !== "" &&
              flightList.arrival.arrivalActual !== "+00:00"
                ? dateFormat( flightList.arrival.arrivalActual,flightList.arrival.timeZone)
                   
                    .time
                : "",
            actual_arrival_date:
              flightList.arrival.arrivalActual &&
              flightList.arrival.arrivalActual !== null &&
              flightList.arrival.arrivalActual !== undefined &&
              flightList.arrival.arrivalActual !== "" &&
              flightList.arrival.arrivalActual !== "+00:00"
                ?dateFormat( flightList.arrival.arrivalActual,flightList.arrival.timeZone)
                   
                    .date
                : "",

            actual_airport_of_origin: flightList.departure.airport || "",
            actual_airport_of_destination: flightList.arrival.airport || "",
            departure_iata_code: flightList.departure.iata || "",
            arrival_iata_code: flightList.arrival.iata || "",
            delay_duration_minutes: flightList.delay_duration_minutes || 0,
          };
        } else if (triggerFrom === "original") {
          // const originalArrivalTime = flightList.arrival.arrivalScheduled || "";
          // const actualArrivalTime =
          //   updatedFlightDetails[triggerIndex].actual_arrival_time || "";

          // let delay = "";
          // if (originalArrivalTime && actualArrivalTime) {
          //   delay = calculateDelay(actualArrivalTime, originalArrivalTime);
          //   setDelay(delay);
          // }

          updatedFlightDetails[triggerIndex] = {
            ...updatedFlightDetails[triggerIndex],
            airport_of_origin: flightList.departure.airport || "",
            airport_of_destination: flightList.arrival.airport || "",
            original_departure_time:
              flightList.departure.departureScheduled &&
              flightList.departure.departureScheduled !== null &&
              flightList.departure.departureScheduled !== undefined &&
              flightList.departure.departureScheduled !== "" &&
              flightList.departure.departureScheduled !== "+00:00"
                ? dateFormat( flightList.departure.departureScheduled,flightList.departure.timeZone)
                   
                    .time
                : "",
            original_departure_date:
              flightList.departure.departureScheduled &&
              flightList.departure.departureScheduled !== null &&
              flightList.departure.departureScheduled !== undefined &&
              flightList.departure.departureScheduled !== "" &&
              flightList.departure.departureScheduled !== "+00:00"
                ? dateFormat( flightList.departure.departureScheduled,flightList.departure.timeZone)
                   
                    .date
                : "",
            original_arrival_time:
              flightList.arrival.arrivalScheduled &&
              flightList.arrival.arrivalScheduled !== null &&
              flightList.arrival.arrivalScheduled !== undefined &&
              flightList.arrival.arrivalScheduled !== "" &&
              flightList.arrival.arrivalScheduled !== "+00:00"
                ? dateFormat( flightList.arrival.arrivalScheduled,flightList.arrival.timeZone)
                   
                    .time
                : "",
            original_arrival_date:
              flightList.arrival.arrivalScheduled &&
              flightList.arrival.arrivalScheduled !== null &&
              flightList.arrival.arrivalScheduled !== undefined &&
              flightList.arrival.arrivalScheduled !== "" &&
              flightList.arrival.arrivalScheduled !== "+00:00"
                ? dateFormat( flightList.arrival.arrivalScheduled,flightList.arrival.timeZone)
                   
                  .date
                
                : "",
            departure_iata_code: flightList.departure.iata || "",
            arrival_iata_code: flightList.arrival.iata || "",
            actual_departure_time:
              flightList.departure.departureActual &&
              flightList.departure.departureActual !== null &&
              flightList.departure.departureActual !== undefined &&
              flightList.departure.departureActual !== "" &&
              flightList.departure.departureActual !== "+00:00"
                ? dateFormat( flightList.departure.departureActual,flightList.departure.timeZone)
                   
                  .time
                : "",
            actual_departure_date:
              flightList.departure.departureActual &&
              flightList.departure.departureActual !== null &&
              flightList.departure.departureActual !== undefined &&
              flightList.departure.departureActual !== "" &&
              flightList.departure.departureActual !== "+00:00"
                ? dateFormat( flightList.departure.departureActual,flightList.departure.timeZone)
                   
                  .date
                : "",
            actual_arrival_time:
              flightList.arrival.arrivalActual &&
              flightList.arrival.arrivalActual !== null &&
              flightList.arrival.arrivalActual !== undefined &&
              flightList.arrival.arrivalActual !== "" &&
              flightList.arrival.arrivalActual !== "+00:00"
                ?dateFormat( flightList.arrival.arrivalActual,flightList.arrival.timeZone)
                   
                  .time
                : "",
            actual_arrival_date:
              flightList.arrival.arrivalActual &&
              flightList.arrival.arrivalActual !== null &&
              flightList.arrival.arrivalActual !== undefined &&
              flightList.arrival.arrivalActual !== "" &&
              flightList.arrival.arrivalActual !== "+00:00"
                ? dateFormat( flightList.arrival.arrivalActual,flightList.arrival.timeZone)
                   
                  .date
                : "",
            
            delay_duration_minutes: flightList.delay_duration_minutes || 0,
          };
        }

       
        if (triggerFrom === "actual") {
          setActualFlightDetails(updatedFlightDetails);
        } else {
          setFlightDetails(updatedFlightDetails);
        }
      }

      setTriggerIndex(null);

      const updatedFlightOptions = { ...flightOptions };
      updatedFlightOptions[flightIndex] = filteredFlightData;
    setFlightOptions(updatedFlightOptions);
    
    multiFlightClose()

      setbackdropopen(false);

  }


  return (
    <div className="modal-wrapper">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropopen}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* <SuccessPopUp
        opened={true}
        close={close2}
        messageText="Claim saved successfully for 72 hours!"
        messagePara="To complete the claim, please access your saved claim on our website <a href='https://flyandclaim.com'>www.flyandclaim.com</a>"
      /> */}


      <Modal
        opened={multiFlightOpened}
        closeOnClickOutside={false}
        onClose={() => {
            setSelectedFlightIndex(null);
            setMultiFlightData(prev => 
              prev.map((f) => ({
                ...f,
                selected: false  // reset all
              }))
          );
         
         
            multiFlightClose();
        }}
        centered
        fullScreen={isMobile}
        size={"1000px"}
        withCloseButton={true}

      >

        <div style={{padding:isMobile ? "0px 0px 20px 0px":"20px"}}>

          <h2 style={{fontSize:"20px",fontWeight:'bold'}}>
            Select Your Flight Details
          </h2>

          {
            multiFlightData?.map((flight, index) => {
              
       
const operationalTimes = flight?.operationalTimes || {};
const status = flight?.status || "";
            
              return (<article className="flight-card" key={index} style={{cursor:"pointer",position:"relative", background: flight?.selected ? "#0084ff05" : "#fff",border:flight?.selected ? "1px solid #457ffdff":"1px solid #e5e7eb" }} onClick={() => {
              handleSelectFlight(index) 
            }}>


<span className="status-chip" style={{position:"absolute",top:"16px",left:"50%",transform:"translateX(-50%)"}}>
          <span className="status-dot" />
           {getFlightStatus(status)}
          
        </span>
      
                <span className="select-flight-radio">
                  <input
                    type="radio"

                    name="selectedFlight"
                    checked={flight?.selected || false}
                    readOnly
                    style={{
    transform: "scale(1.5)",     // size
    accentColor: flight?.selected ? "#457ffdff" : "gray"  // color
  }}
                  />
                </span>


      {/* <header className="flight-header-new">
        {
          flight?.airline?.iata &&  <div className="airline-badge">{flight?.airline?.iata}</div>
       }
        <div className="title">
          <h1>
            {flight?.airline?.name} • {flight?.flight?.number}
          </h1>
         
        </div>

      
        
      
      </header> */}

      <section className="content">
        <div className="route" style={{position:"relative"}}>
          <div className="ap">
            {flight?.departure?.iata && <div className="code">{flight?.departure?.iata}</div>}
            <div className="city">
              {flight?.departure?.airport}
            </div>
            {/* <div className="meta">
                      {flight?.departure?.terminal && <span>Terminal {flight?.departure?.terminal}</span>}  
                      {flight?.departure?.gate && <span>Gate {flight?.departure?.gate}</span>} 
            </div>
            <div className="meta">
               {flight?.departure?.timezone && <span>Timezone: {flight?.departure?.timezone}</span>} 
            
            </div> */}
          </div>
  
          <div className="plane">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M21 16v-2l-8-5V3.5a1.5 1.5 0 0 0-3 0V9L2 14v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5z" />
            </svg>
          </div>

          <div className="ap" style={{ textAlign: "right" }}>
            <div className="code">{flight?.arrival?.iata}</div>
            <div className="city">
              {flight?.arrival?.airport}
            </div>
            {/* <div className="meta" style={{ justifyContent: "flex-end" }}>
                      {flight?.arrival?.terminal && <span>Terminal {flight?.arrival?.terminal}</span>} 
                       {flight?.arrival?.gate && <span>Gate {flight?.arrival?.gate}</span>}
            </div>

              <div className="meta" style={{ justifyContent: "flex-end" }}>
               {flight?.arrival?.timezone && <span>Timezone: {flight?.arrival?.timezone}</span>} 
            
            </div> */}
          </div>
        </div>

      



        <div className="new-flight-timing-wrapper">
                <div style={{border:"1px solid #ddd"}}>
                   <h5 className="new-flight-timing-title">
                              <IconPlaneDeparture size={'20px'} /> Departure
                  </h5>
                  <div className="new-flight-timing-grid">
                      <div className="new-flight-timing">
                    <span className="new-flight-timing-label">Scheduled Departure</span>
                    <span className="new-flight-timing-date">{fmt(operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal || operationalTimes?.estimatedGateDeparture?.dateLocal )}</span>
                    {/* <span className="new-flight-timing-scheduled" >Scheduled {fmt(operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span> */}
                    </div>
      
                    {
                       (status !== "C" && status !== "DN" && status !== "S" && status !== "Scheduled" ) &&  <div className="new-flight-timing">
                    <span className="new-flight-timing-label">Gate Departure</span>
                    <span className="new-flight-timing-date">{fmt(operationalTimes?.actualGateDeparture?.dateLocal || operationalTimes?.estimatedGateDeparture?.dateLocal || operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span>
                    {/* <span className="new-flight-timing-scheduled" >Scheduled {fmt(operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span> */}
                    </div>
                    }
                    
                    {
                       (status === "C" || status === "DN" || status === "S" || status === "Scheduled" ) &&  <div className="new-flight-timing">
                    <span className="new-flight-timing-label">Estimated Departure</span>
                    <span className="new-flight-timing-date">{fmt(operationalTimes?.estimatedGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span>
                    {/* <span className="new-flight-timing-scheduled" >Scheduled {fmt(operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span> */}
                    </div>
                    }
                    
                    {
                      (status === "A" || status === "L" || status === "D" || status === "R") &&   <div className="new-flight-timing">
                    <span className="new-flight-timing-label">Takeoff</span>
                    <span className="new-flight-timing-date">{fmt(operationalTimes?.actualRunwayDeparture?.dateLocal || operationalTimes?.estimatedRunwayDeparture?.dateLocal || operationalTimes?.actualGateDeparture?.dateLocal || operationalTimes?.estimatedGateDeparture?.dateLocal || operationalTimes?.scheduledRunwayDeparture?.dateLocal || operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span>
                    {/* <span className="new-flight-timing-scheduled" >Scheduled {fmt(operationalTimes?.estimatedRunwayDeparture?.dateLocal || operationalTimes?.actualGateDeparture?.dateLocal || operationalTimes?.estimatedGateDeparture?.dateLocal || operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span> */}
                    </div>
                    }
                   
                  </div>
                 
                </div>
      
                 <div style={{border:"1px solid #ddd"}}>
                   <h5 className="new-flight-timing-title">
                              <IconPlaneArrival size={'20px'} /> Arrival
                  </h5>
                  <div className="new-flight-timing-grid">
                     <div className="new-flight-timing">
                    <span className="new-flight-timing-label">Scheduled Arrival</span>
                    <span className="new-flight-timing-date">{fmt(operationalTimes?.scheduledGateArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal || operationalTimes?.estimatedGateArrival?.dateLocal )}</span>
                    {/* <span className="new-flight-timing-scheduled" >Scheduled {fmt(operationalTimes?.scheduledGateDeparture?.dateLocal || operationalTimes?.publishedDeparture?.dateLocal)}</span> */}
                   
                    </div>
      
                    {
                      (status === 'S' || status === "U" || status === "A" || status === "D" || status === "C" || status === "R" || status === "Scheduled") &&  <div className="new-flight-timing">
                    <span className="new-flight-timing-label">Estimated Arrival</span>
                    <span className="new-flight-timing-date">{fmt( operationalTimes?.estimatedGateArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal)}</span>
                    {/* <span className="new-flight-timing-scheduled" >Scheduled {fmt(operationalTimes?.estimatedRunwayArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal)}</span> */}
                   
                    </div>
                    }
      
                    {
                      (status === "L" ) &&  <div className="new-flight-timing">
                    <span className="new-flight-timing-label">Landing</span>
                    <span className="new-flight-timing-date">{fmt(operationalTimes?.actualRunwayArrival?.dateLocal || operationalTimes?.estimatedRunwayArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal)}</span>
                    {/* <span className="new-flight-timing-scheduled" >Scheduled {fmt(operationalTimes?.estimatedRunwayArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal)}</span> */}
                   
                    </div>
                    }
                    
                  
                    {
                       (status === "L" || status === "D" ) &&  <div className="new-flight-timing">
                    <span className="new-flight-timing-label">Gate Arrival</span>
                    <span className="new-flight-timing-date">{fmt(operationalTimes?.actualGateArrival?.dateLocal || operationalTimes?.estimatedGateArrival?.dateLocal || operationalTimes?.scheduledGateArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal )}</span>
                    {/* <span className="new-flight-timing-scheduled" >Scheduled {fmt(operationalTimes?.scheduledGateArrival?.dateLocal || operationalTimes?.publishedArrival?.dateLocal )}</span> */}
                    </div>
                     }
                     
                  </div>
                 
                </div>
              </div>
      </section>

      
       
    </article>)
              
            
              
               })
          }
          
          <div style={{display:"flex",justifyContent:"flex-end",marginTop:"20px",gap:"15px"}}>
            <CustomButton btnText={'Apply'} onClick={handleSaveFlightDetails} style={{width:"200px"}} disabled={selectedFlightIndex === null} />
          </div>

        </div>

        </Modal>


        <Modal
            opened={opened}
            onClose={close2}
            centered
            radius={"xl"}
            size={"lg"}
            withCloseButton={false}
          >
            <div className="universal-modal-wrapper">
              <CircleTickIcon />
              <h1
                className="header"
                style={{ color: "#314064", textAlign: "center" ,fontSize:"40px",lineHeight:"55px"}}
          >Claim saved successfully for 72 hours!
            
              </h1>
              <p
                style={{ textAlign: "center", color: "#222222" }}
                className="sub-header"
              >
                To complete the claim, please access your saved claim on our website <a href='https://flyandclaim.com'>www.flyandclaim.com</a>
              </p>
              <CustomButton
                style={{ width: "50%" }}
                btnText={"BACK"}
                flex={1}
                onClick={close2}
              />
            </div>
          </Modal>

      <SuccessPopUp
        opened={opened2}
        close={close3}
        messageText="Updated Form successfully!"
        messagePara="Your form has been updated successfully."
      />
      {/* <SurewanttoExit
        opened={opened3}
        handleSaveClick={handleSaveClick}
        messageText="Are you sure!"
        messagePara="Do you want to save your form before exiting ?"
        open2={open2}
        close={close4}
        active={active}
      /> */}


       <Modal
      opened={temporaryOpened}
      onClose={()=>setTemporaryOpened(false)}
     
      centered
      radius="md"
        size="md"
           padding={0}
        styles={{
          header: {
            padding:"0px 15px"
          }
        }}
        closeOnClickOutside={false}
      >
        
        <div className="instruct-modal-wrapper
        
        ">

          <h2>
            Before saving the page
          </h2>

          <ul>
            {/* <li>You need to create an account.</li> */}
            <li>Your claim will be saved temporarily for <b>72 hours</b>.</li>
            <li>After 72 hours, the temporary claim will be deleted automatically.</li>
            <li>You will receive an email with a link to access and continue your temporary claim.</li>
          
           
           
          </ul>

           {/* <p style={{textAlign:"center",color:"#ff4b4bff",borderColor:"#ff4b4bff",background:"rgb(255 170 170 / 5%)",borderRadius:"6px"}}>Please register or sign in to securely save and continue later.</p> */}
       
          <div style={{display:"flex",justifyContent:"center",marginTop:"20px"}}>
            
      <CustomButton btnText={'Continue'} onClick={handleSaveClick} style={{width:"200px"}} />
         </div>
        </div>

      

       
     
    </Modal>



      <SurewanttoExit
        opened={opened3}
        handleSaveClick={() => {
          localStorage.removeItem("travelerInformationData");
          localStorage.removeItem("claimType");
          localStorage.removeItem("OriginallyBookedFlightsData");
          localStorage.removeItem("actualFlightDetailsData");
          localStorage.removeItem("completedStep");

          // Navigate to the start page
          navigate("/start-your-claim");
        }}
        messageText="Are you sure!"
        messagePara="Do you want to discard the claim ?"
        open2={open2}
        isNew={true}
        close={close4}
        active={active}
        btnCancelText="No"
        btnSavetext="Yes"
      />

      <Modal closeOnClickOutside={false} opened={isRegisterModalOpen} onClose={() => {   authFlow('none')} } size={'xl'}>
        
        {
          openLogin && <LoginComponent  authFlow={authFlow} />
        
        }

        {
          
          openRegister && <RegisterComponent authFlow={authFlow} />
        }
        
       
       
      </Modal>

        <Modal 

                opened={isPowerOfAttorneyFetchedErrorModal}
        onClose={() => { setIsPowerOfAttorneyFetchedErrorModal(false); setIsPowerLinkClicked(false)}}
               
                closeOnClickOutside={false}
        centered
        radius={isMobile ? "lg" : "xl"}
        size={"md"}

              >
                <div style={{textAlign:"center",padding:"0px 0px 30px 0px"}}>
         
          <h2 className="">Opps!</h2>
          <p>
            Something went wrong
          </p>

          <CustomButton style={{width:"200px",marginTop:"30px"}} btnText={'Try Again'} onClick={() => {
            setIsPowerOfAttorneyFetchedErrorModal(false)
            getPowerOfAttorney()
          }} />

          
          
         
                </div>
              </Modal>

      <SuccessPopUp
        opened={opened2}
        close={close3}
        messageText="Updated Form successfully!"
        messagePara="Your form has been updated successfully."
      />

      <Modal
        opened={additionalClaimModalOpened}
        onClose={closeAdditionalClaim}
        centered
        radius={isMobile ? "lg" : "xl"}
        size={"lg"}
        withCloseButton={false}
      >
        <div className="additional-claim-modal">
          <h4 className="stepper-header">Add Additional Claim</h4>

          {additionalClaimData?.length > 0 &&
            additionalClaimData?.map((claimData, index) => (
              <React.Fragment key = { index }>
                <div className="flight-add-wrapper">
                  <h5>Claim {index + 1}</h5>
                  {(additionalClaimData.length > 1 || claimData.id) && (
                    <div
                      style={{
                        backgroundColor: "none",
                        color: "red",
                        cursor: "pointer",
                        marginLeft: "2px",
                        textAlign: "right",
                      }}
                      onClick={() => removeAdditionalData(index)}
                    >
                      <RemoveCircleOutline />
                    </div>
                  )}
                </div>
                <div className="grid-two" style={{ marginTop: "30px" }}>
                  <div>
                    <label
                      className="input-label"
                      style={{ marginBottom: "10px" }}
                    >
                      {" "}
                      Select Claim Type
                    </label>
                    <Select
                      placeholder="Select Claim"
                      data={[
                        { value: "lost_baggage", label: "Lost Baggage" },
                        { value: "damage_baggage", label: "Damage Baggage" },
                        { value: "travel_expenses", label: "Travel Expenses" },
                        { value: "delayed_baggage", label: "Delayed Baggage" },
                        { value: "others", label: "Others" },
                      ]}
                      value={claimData.claim_type}
                      onChange={(value) => {
                        handleFormChange("claim_type", value, index);
                      }}
                      withCheckIcon={false}
                      comboboxProps={{
                        position: "bottom",
                        middlewares: { flip: false, shift: false },
                        offset: 0,
                      }}
                      rightSection={<SelectIcon />}
                    />

                    {additionalClaimValidation[index].claim_type && (
                      <span className="error-text">
                        {" "}
                        Please select a claim type
                      </span>
                    )}
                  </div>
                  <div className="custom-input" style={{ width: "100%" }}>
                    <label className="input-label"> Claim document</label>
                    <input
                      id={`additional-${index}`}
                      type="file"
                      onChange={(e) => {
                        handleFileChange(e, index);
                      }}
                      accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,.webp"
                      className="hidden"
                    />
                    <div
                      onClick={() =>
                        document.getElementById(`additional-${index}`).click()
                      }
                      className="input-box"
                      style={{
                        color: claimData.other_claim_doc
                          ? "#222222"
                          : "#7b8287",
                      }}
                    >
                      {getAddionalClaimFileName(index)}
                      <UploadIcon />
                    </div>
                    {additionalClaimValidation[index].other_claim_doc && (
                      <span className="error-text">
                        Please attach claim documents
                      </span>
                    )}
                  </div>
                </div>

                <div className="grid-two" style={{ marginTop: "30px" }}>
                  <div className="custom-input" style={{ width: "100%" }}>
                    <label className="input-label"> Amount</label>

                    <Select
                      placeholder="Select Claim"
                      data={[
                        { value: "usd", label: "USD" },
                        { value: "eur", label: "EURO" },
                      ]}
                      value={claimData.currency_type}
                      onChange={(value) => {
                        handleFormChange("currency_type", value, index);
                      }}
                      withCheckIcon={false}
                      comboboxProps={{
                        position: "bottom",
                        middlewares: { flip: false, shift: false },
                        offset: 0,
                      }}
                      rightSection={<SelectIcon />}
                    />

                    {additionalClaimValidation[index].amount && (
                      <span className="error-text">
                        {" "}
                        Please enter claim amount
                      </span>
                    )}
                  </div>

                  <div className="custom-input" style={{ width: "100%" }}>
                    <label className="input-label"> Amount</label>

                    <NumberInput
                      placeholder="Enter Amount"
                      hideControls
                      value={claimData.amount}
                      onChange={(value) => {
                        handleFormChange("amount", value, index);
                      }}
                    />

                    {additionalClaimValidation[index].amount && (
                      <span className="error-text">
                        {" "}
                        Please enter claim amount
                      </span>
                    )}
                  </div>
                </div>

                <div style={{ marginTop: "30px" }}>
                  <label
                    className="input-label"
                    style={{ marginBottom: "10px" }}
                  >
                    Additional Details
                  </label>

                  <textarea
                    rows={6}
                    placeholder="Add any relevant details about your claim  "
                    value={claimData.claim_explanation}
                    onChange={(e) => {
                      handleFormChange(
                        "claim_explanation",
                        e.target.value,
                        index
                      );
                    }}
                    className="input-box"
                  />

                  {additionalClaimValidation[index].claim_explanation && (
                    <span className="error-text">
                      Please enter additional details
                    </span>
                  )}
                </div>
              </React.Fragment>
            ))}
          <div className="additional-claim-btn-wrapper">
            <CustomButton
              type="secondary"
              btnText="Cancel"
              onClick={() => {
                // Handle cancel action here
                // setAdditionalClaimData([
                //   {
                //     claim_type: "",
                //     claim_explanation: "",
                //     amount: "",
                //     other_claim_doc: null,
                //     currency_type: "usd",
                //     other_claim_doc_name: null,
                //   },
                // ]);
                // setAdditionalClaimValidation([
                //   {
                //     claim_type: false,
                //     amount: false,
                //     claim_explanation: false,
                //     other_claim_doc: false,
                //   },
                // ]);
                closeAdditionalClaim();
              }}
            />
            <CustomButton
              type="secondary"
              btnText="Add Claim"
              onClick={() => {
                // Handle adding the claim here
                addAdditionalData();
              }}
            />
            <CustomButton
              type="primary"
              btnText="Done"
              onClick={() => {
                // Handle adding the claim here
                handleAdditionalClaimType();
              }}
            />
          </div>
        </div>
      </Modal>

      <div>
        <div className="modal-toolbar">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <Back
                // onClick={() => {
                   onClick={handleBack}
                  // if (active > 1) {
                  //   setActive((current) => current - 1);
                  // }
                // }}
                style={{ cursor: "pointer" }}
              />
              <span className="stepper-count">Step {active}/7</span>
            </div>
            <Link to={"/"}>
              <Logo />
            </Link>

            <div className="stepper-save-btn">
               {/* {(active === 2 ||
                active === 3 ||
                active === 4 ||
                active === 5 ||
                active === 6 ||
                active === 7) && (
                <CustomButton
                  type="secondary"
                  style={{ marginRight: "10px" }}
                  btnText="SAVE"
                  onClick={handleSaveClick}
                />
              )}  */}

              <Close onClick={handleOpen4} />
            </div>
            <div className="mobile-close-btn">
              <Close onClick={handleOpen4} />
            </div>
          </div>
          <div style={{ marginTop: "20px" }} className="stepper-progress-bar">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  lineHeight: "20px",
                  color: "#314064",
                  fontWeight: 500,
                }}
              >
                {active === 1
                  ? "Traveler information"
                  : active === 2
                  ? "Claim details"
                  : active === 3
                  ? "Originally booked flights"
                  : active === 4
                  ? "Actual flights taken"
                  : active === 5
                  ? "Upload required documents"
                  // : active === 6
                  // ? "Save or continue as guest"
                  : active === 6
                  ? "Attorney notes"
                  : active === 7
                  ? "Submission results"
                  : "Fly claim"}
              </span>
              <span
                style={{
                  fontSize: "14px",
                  lineHeight: "20px",
                  color: "#314064",
                  fontWeight: 700,
                }}
              >
                Step {active}/7
              </span>
            </div>
            <div
              style={{
                height: "4px",
                borderRadius: "2px",
                overflow: "hidden",
                backgroundColor: "#E6F6FF",
              }}
            >
              <div
                style={{
                  width: `${active * 13}%`,
                  height: "4px",
                  borderRadius: "2px",
                  backgroundColor: "#314064",
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal-main-wrapper">
        <div className="modal-main-left">
          <h4>Your claim progress</h4>
          <div>
            <Stepper
              active={getformData?.claimDetails?.type_of_claim === "lost/damaged" && active > 3 ? active - 1 : active }
              // onStepClick={(step) => {
              //   // Only allow going to completed steps (steps before current active)
               
              //   // handleNext()
              //   if (getformData?.claimDetails?.type_of_claim === "cancelled" && step === 3) {
              //     return
              //   }

              //   if (getformData?.claimDetails?.type_of_claim === "lost/damaged" && step === 2) {
              //     return
              //   }
              //   if (step < completedStep) {
              //     setActive(step + 1);
              //   }
              // }}
              allowStepSelect={false}
              icon={false}
              orientation="vertical"
              mt={"xl"}
              completedIcon={<CheckIcon />}
              styles={{
                stepCompletedIcon: {
                  background: "#314064",
                  borderRadius: "50%",
                },
                stepLabel: {
                  paddingTop: "15px",
                  color: "#7B8287",
                  cursor: (step) => (step < active - 1 ? "pointer" : "default"),
                },
                stepDescription: {
                  display: "none",
                },
                stepIcon: {
                  background: "#E6F6FF",
                  border: 0,
                },
                separator: {
                  borderColor: "#314064",
                },
              }}
            >
              <Stepper.Step label="Traveler information" />
              <Stepper.Step label="Claim details" />
              {
                getformData?.claimDetails?.type_of_claim !== "lost/damaged" &&  <Stepper.Step label="Originally booked flights" />
              }
             
              
              <Stepper.Step label={getformData?.claimDetails?.type_of_claim !== "lost/damaged" ?  "Actual flights taken":"Flight details"} />
              <Stepper.Step label="Upload required documents" />
              {/* <Stepper.Step label="Save or continue as guest" /> */}
              <Stepper.Step label="Attorney notes" />
              <Stepper.Step label="Submission results" />
            </Stepper>
          </div>
        </div>

        <div className="modal-main-right">
          {active === 1 && (
            <TravelerInformation
              setStepone={setStepone}
              onSubmit={handleFormSubmit}
              familyMembers={familyMembers}
              handleInputChange={handleInputChange}
              handleTicketNumberChange={handleTicketNumberChange}
              ticketNumberErrors={ticketNumberErrors}
              handlePassportUpload={handlePassportUpload}
              handleAdditionalUpload={handleAdditionalUpload}
              removeFamilyMember={removeFamilyMember}
              register={register}
              errors={errors}
              control={control}
              watch={watch}
              setIsOpen={setIsOpen}
              isOpen={isOpen}
              handleSelect={handleSelect}
              handleMobileInputChange={handleMobileInputChange}
              mobile={mobile}
              setMobile={setMobile}
              country1={country1}
              setcountry={setcountry}
              countryValid={countryValid}
              setCountryValid={setCountryValid}
              handleAddressChange={handleAddressChange}
              optionsList={optionsList}
              isOpenList={isOpenList}
              handleInputBlur={handleInputBlur}
              handleAddressInputChange={handleAddressInputChange}
              ticket={ticket}
              setTicket={setTicket}
              isAddressDropdownOpen={isAddressDropdownOpen}
              setIsAddressDropdownOpen={setIsAddressDropdownOpen}
              handleClickAddressDropdown={handleClickAddressDropdown}
              handleTicketInputChange={handleTicketInputChange}
              // setFetchedFormTraveler={setFetchedFormTraveler}
              setClaimData={setClaimData}
              claimData={claimData}
              setPdfBlob={setPdfBlob}
              pdfBlob={pdfBlob}
              signatureCaptured={signatureCaptured}
              setSignatureCaptured={setSignatureCaptured}
              setFamilyMembers={setFamilyMembers}
              clearPoaAndAgreement={clearPoaAndAgreement}
            />
          )}
          {active === 2 && (
            <ClaimDetails
              setSteptwo={setSteptwo}
              onSubmit={handleFormSubmit}
              setClaimData={setClaimData}
              claimData={claimData}
            />
          )}
          {active === 3 && (
            <OriginallyBookedFlights
              setStepthree={setStepthree}
              onSubmit={handleFormSubmit}
              flightDetails={flightDetails}
              setFlightDetails={setFlightDetails}
              RemoveCircleOutline={RemoveCircleOutline}
              removeFlightDetails={removeFlightDetails}
              setTriggerIndex={setTriggerIndex}
              errors={errors}
              flightOptions={flightOptions}
              loadOptions={loadOptions}
              control={control}
              defaultOptions={defaultOptions}
              defaultAirlineOptions={defaultAirlineOptions}
              setTriggerFrom={setTriggerFrom}
              loadAirlineOptions={loadAirlineOptions}
              getformData={getformData}
              claimId={id}
              claimData={claimData}
              type_of_claim={getformData?.claimDetails?.type_of_claim}
              flightClassOptions={flightClassOptions}
            />
          )}
          {active === 4 && (
            <ActualFlightTaken
               type_of_claim={getformData?.claimDetails?.type_of_claim}
              flightDetails={flightDetails}
              setStepfour={setStepfour}
              onSubmit={handleFormSubmit}
              actualFlightDetails={actualFlightDetails}
              setActualFlightDetails={setActualFlightDetails}
              isFlightProvided={isFlightProvided}
              setIsFlightProvided={setIsFlightProvided}
              setTriggerIndex={setTriggerIndex}
              defaultOptions={defaultOptions}
              defaultAirlineOptions={defaultAirlineOptions}
              setTriggerFrom={setTriggerFrom}
              loadAirlineOptions={loadAirlineOptions}
              loadOptions={loadOptions}
              flightOptions={flightOptions}
              getformData={getformData}
              claimId={id}
              claimData={claimData}
              removeActualFlightDetails={removeActualFlightDetails}
              RemoveCircleOutline={RemoveCircleOutline}
              flightClassOptions={flightClassOptions}
              lostAmount={lostAmount}
              setLostAmount={setLostAmount}
            />
          )}
          {active === 5 && (
            <UploadRequiredDocument
              setStepfive={setStepfive}
              onSubmit={handleFormSubmit}
              lengthofTraveler={getformData?.travelerInfo?.sub_claims?.length}
              handleAdditionalFileChange={handleAdditionalFileChange}
              handleLuggageFileChange={handleLuggageFileChange}
              familyMembers={familyMembers}
              handlePassportUpload={handlePassportUpload}
              handleAdditionalUpload={handleAdditionalUpload}
              handleBoardingUpload={handleBoardingUpload}
              removeFamilyMember={removeFamilyMember}
              boardingImg={boardingImg}
              passportImg={passportImg}
              additionalImg={additionalImg}
              handleViewFile={handleViewFile}
              selectedAdditionalFiles={selectedAdditionalFiles}
              selectedLuggageFiles={selectedLuggageFiles}
              selectBoardingFile={selectBoardingFile}
              setSelectBoardingFile={setSelectBoardingFile}
              selectPassportFile={selectPassportFile}
              setSelectPassportFile={setSelectPassportFile}
             type_of_claim={getformData?.claimDetails?.type_of_claim}
            />
          )}
          {/* {active === 6 && (
            <SaveOrContinueAsGuest
              setStepsix={setStepsix}
              onSubmit={handleFormSubmit}
              setUserChecked={setUserChecked}
              userChecked={userChecked}
            />
          )} */}
          {active === 6 && (
            <Attorneynotes
             setStepsix={setStepsix}
              isTermsChecked={isTermsChecked}
              handleTermsChange={handleTermsChange}
              handleTermsLinkClick={handleTermsLinkClick}
              isAgreementChecked={isAgreementChecked}
              handleCheckAgreement={handleCheckAgreement}
              handleAgreementChange={handleAgreementChange}
              openAgreementModal={openAgreementModal}
              openPowerOfAttorneyModal={openPowerOfAttorneyModal}
              handlePowerOfAttorneyChange={handlePowerOfAttorneyChange}
              handleCheckPowerOfAttorney={handleCheckPowerOfAttorney}
              signatureCaptured={signatureCaptured}
              onSubmit={handleFormSubmit}
              familyMembers={familyMembers}
              isPowerOfAttorneyChecked={isPowerOfAttorneyChecked}
              pdfBlob={pdfBlob}
              poaPdf={poaPdf}
              isAgreementModalOpen={isAgreementModalOpen}
              closeAgreementModal={closeAgreementModal}
              handleSignatureAdded={handleSignatureAdded}
              handlePdfGenerated={handlePdfGenerated}
              setEnvelopeId={setEnvelopeId}
              envolpeId={envolpeId}
              setIsDocusignModalOpen={setIsDocusignModalOpen}
              signUrl={signUrl}
              setSignUrl={setSignUrl}
              setIsFetching={setIsFetching}
              setDocumentFetched={setDocumentFetched}
              activeTab={activeTab}
              dataToStore={dataToStore}
              isDocuSignModalOpen={isDocuSignModalOpen}
              handleIframeClose={handleIframeClose}
              powerRef={powerRef}
              previousNote={previousNote}
              isPowerOfAttorneyFetchedErrorModal={isPowerOfAttorneyFetchedErrorModal}
              signers={signers}
              setSigner={setSigners}
              draftNote={draftNote}
              setDraftNote={setDraftNote}
               setPowerPdf={setPowerPdf}
    setPoaPdf={setPoaPdf}
            />
          )}
          {active === 7 && (
            <ConfirmationStatus
              geteligible={geteligible}
              seteligible={seteligible}
              getclaimid={getclaimid}
              setStepseven={setStepseven}
            />
          )}
          <div className="stepper-btn-wrapper">
            <div className="back-btn">
              {active > 1 && active !== 7 && (
                <CustomButton
                  btnText={"Back"}
                  type="secondary"
                  onClick={() => {
                     if (getformData?.claimDetails?.type_of_claim === "cancelled" && active === 5) {
                       setActive((current) => current - 2);
                    }else if (getformData?.claimDetails?.type_of_claim === "lost/damaged" && active === 4) {
                       setActive((current) => current - 2);
                    } else {
                       setActive((current) => current - 1);
                      
                    }
                  }}
                />
              )}
            </div>

            <div className="add-btn-wrapper">
              {active === 1 && (
                <CustomButton
                  btnText="ADD TRAVELER"
                  color="primary"
                  onClick={addFamilyMember}
                  className="mt-3 mb-3"
                  style={{ width: "180px" }}
                  type="secondary"
                />
              )}
              {active === 3 && (
                <CustomButton
                  btnText="ADDITIONAL FLIGHT"
                  color="primary"
                  onClick={addFlightDetails}
                  className="mt-3 mb-3"
                  // style={{ width: "200px" }}
                  type="secondary"
                />
              )}
              {isFlightProvided === "yes" && (
                <>
                  {active === 4 && (
                    <CustomButton
                      btnText="ADD FLIGHT"
                      color="primary"
                      onClick={addActualFlightDetails}
                      className="mt-3 mb-3"
                      style={{ width: "180px" }}
                      type="secondary"
                    />
                  )}
                </>
              )}
              {/* {active === 5 && (
                <CustomButton
                  btnText="ADD PASSENGER"
                  color="primary"
                  onClick={addFamilyMember}
                  className="mt-3 mb-3"
                  style={{ width: "180px" }}
                  type="secondary"
                />
              )} */}

              {/* {active === 4 && (
                <CustomButton
                  btnText="ADD ADDITIONAL CLAIM"
                  color="primary"
                  onClick={addAdditionalClaim}
                  className="mt-3 mb-3"
                  type="secondary"
                />
              )} */}

              
              
              <div className="next-btn">
                 {(active === 2 ||
                active === 3 ||
                active === 4 ||
                active === 5 ||
                active === 6 ) && (
                <CustomButton
                  type="secondary"
                  style={{ marginRight: "10px" }}
                  btnText="Temporary SAVE"
                  onClick={()=>setTemporaryOpened(true)}
                />
              )} 
                {active !== 7 && (
                  <CustomButton
                    btnText={getButtonText()} // Set button text dynamically
                    type={
                      active === 1
                        ? stepone
                          ? "primary"
                          : "disable"
                        : active === 2
                        ? steptwo
                          ? "primary"
                          : "disable"
                        : active === 3
                        ? stepthree
                          ? "primary"
                          : "disable"
                        : active === 4
                        ? stepfour
                          ? "primary"
                          : "disable"
                        : active === 5
                        ? stepfive
                          ? "primary"
                          : "disable"
                        : active === 6
                        ? stepsix
                          ? "primary"
                          : "disable"
                        : active === 7
                        ? stepseven
                          ? "primary"
                          : "disable"
                        : "primary"
                    }
                    onClick={handleNext}
                    disabled={
                      active === 1
                        ? !stepone
                        : active === 2
                        ? !steptwo
                        : active === 3
                        ? !stepthree
                        : active === 4
                        ? !stepfour
                        : active === 5
                        ? !stepfive
                        : active === 6
                        ? !stepsix
                        : active === 7
                        ? !stepseven
                        : false
                    }
                  />
                )}
              </div>
            </div>

            
          </div>
          <div style={{display:"flex",justifyContent:"flex-end",marginTop:"20px"}}>

            {active < 6 &&
          <p style={{fontSize:"15px",marginBootom:"0 !important"}}><span style={{color:"#de8385"}}>*</span> Please fill all required fields</p>
        
            }
        </div>
        </div>

        <div
          className="mobile-btn-wrapper"
          style={{
            display: "flex",
            padding: "10px 20px",
            gap: "10px",
            background: "#fff",
          }}
        >
          {(active === 2 ||
            active === 3 ||
            active === 4 ||
            active === 5 ||
            active === 6 ) && (
            <div>
              <CustomButton
                type="secondary"
                btnText="SAVE"
                onClick={()=>setTemporaryOpened(true)}
              />
            </div>
          )}

          {active !== 7 && (
            <div style={{ flex: 1 }}>
              <CustomButton
                btnText={getButtonText()} // Set button text dynamically
                type={
                  active === 1
                    ? stepone
                      ? "primary"
                      : "disable"
                    : active === 2
                    ? steptwo
                      ? "primary"
                      : "disable"
                    : active === 3
                    ? stepthree
                      ? "primary"
                      : "disable"
                    : active === 4
                    ? stepfour
                      ? "primary"
                      : "disable"
                    : active === 5
                    ? stepfive
                      ? "primary"
                      : "disable"
                    : active === 6
                    ? stepsix
                      ? "primary"
                      : "disable"
                    : active === 7
                    ? stepseven
                      ? "primary"
                      : "disable"
                    : "primary"
                }
                onClick={handleNext}
                disabled={
                  active === 1
                    ? !stepone
                    : active === 2
                    ? !steptwo
                    : active === 3
                    ? !stepthree
                    : active === 4
                    ? !stepfour
                    : active === 5
                    ? !stepfive
                    : active === 6
                    ? !stepsix
                    : active === 7
                    ? !stepseven
                    : false
                }
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FileaClaim;
